/*!
 * (c) 2026 Ocean Essentials Limited (HK). All rights reserved.
 * Proprietary code. Licensed, not sold. See LICENSE.md and Services Agreement.
 */
window.mastMapping = {
  constant: {
    RDM: {
      340: {
        essentials: {
          base: {
            handle: "essentials-rdm-c50-constant-curve-340-incl-mastbag",
            name: "Essentials RDM C50 Constant Curve 340 Incl. Mastbag",
            sku: "UF095510340",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_Essential_CC_RDM_TF_609.png?v=1738340046",
            specs: {
              length: 340,
              diameter: "RDM",
              curve: "Constant Curve",
              carbon: "C50",
              carbonQuality: "T700",
              imcs: 14,
              baseFlex: 62.5,
              topFlex: 76,
              finishing: "Matte Black Spiral Taped",
              ferrule: "Universal Ferrule System",
              maxInsertion: "Maximum 60",
              weight: 1.75,
            },
          },
          mastOnly: {
            handle: "essentials-rdm-c50-constant-curve-340",
            name: "Essentials RDM C50 Constant Curve 340",
            sku: "UF005510340",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_Essential_CC_RDM_TF_609.png?v=1738340046",
          },
          withBag: {
            handle: "essentials-rdm-c50-constant-curve-340-incl-mastbag",
            name: "Essentials RDM C50 Constant Curve 340 Incl. Mastbag",
            sku: "UF095510340",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_Essential_CC_RDM_TF_609.png?v=1738340046",
          },
        },
        hd: {
          base: {
            handle: "hd-rdm-c75-constant-curve-340-incl-mastbag",
            name: "HD RDM C75 Constant Curve 340 Incl. Mastbag",
            sku: "UF095710340",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_HD_CC_RDM_TF_594_d69b0a01-335d-40c1-ba79-1f9e2249b554.png?v=1738345094",
            specs: {
              length: 340,
              diameter: "RDM",
              curve: "Constant Curve",
              carbon: "C75",
              carbonQuality: "T700",
              imcs: 14,
              baseFlex: 62.5,
              topFlex: 76,
              finishing: "Matte Black Spiral Taped",
              ferrule: "Universal Ferrule System",
              maxInsertion: "Maximum 60",
              weight: 1.36,
            },
          },
          mastOnly: {
            handle: "hd-rdm-c75-constant-curve-340",
            name: "HD RDM C75 Constant Curve 340",
            sku: "UF005710340",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_HD_CC_RDM_TF_594_d69b0a01-335d-40c1-ba79-1f9e2249b554.png?v=1738345094",
          },
          withBag: {
            handle: "hd-rdm-c75-constant-curve-340-incl-mastbag",
            name: "HD RDM C75 Constant Curve 340 Incl. Mastbag",
            sku: "UF095710340",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_HD_CC_RDM_TF_594_d69b0a01-335d-40c1-ba79-1f9e2249b554.png?v=1738345094",
          },
        },
        elite: {
          base: {
            handle: "elite-rdm-c100-constant-curve-340-incl-mastbag",
            name: "Elite RDM C100 Constant Curve 340 Incl. Mastbag",
            sku: "UF095910340",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_Elite_CC_RDM_TF_606.png?v=1738340918",
            specs: {
              length: 340,
              diameter: "RDM",
              curve: "Constant Curve",
              carbon: "C100",
              carbonQuality: "T700 & T800",
              imcs: 14,
              baseFlex: 62.5,
              topFlex: 76,
              finishing: "Matte Black Spiral Taped",
              ferrule: "Universal Ferrule System",
              maxInsertion: "Maximum 60",
              weight: 1.21,
            },
          },
          mastOnly: {
            handle: "elite-rdm-c100-constant-curve-340",
            name: "Elite RDM C100 Constant Curve 340",
            sku: "UF005910340",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_Elite_CC_RDM_TF_606.png?v=1738340918",
          },
          withBag: {
            handle: "elite-rdm-c100-constant-curve-340-incl-mastbag",
            name: "Elite RDM C100 Constant Curve 340 Incl. Mastbag",
            sku: "UF095910340",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_Elite_CC_RDM_TF_606.png?v=1738340918",
          },
        },
      },
      370: {
        essentials: {
          base: {
            handle: "essentials-rdm-c50-constant-curve-370-incl-mastbag",
            name: "Essentials RDM C50 Constant Curve 370 Incl. Mastbag",
            sku: "UF095510370",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_Essential_CC_RDM_TF_609_e4dcc795-6d8f-4627-91ab-b52d88dfd104.png?v=1738391333",
            specs: {
              length: 370,
              diameter: "RDM",
              curve: "Constant Curve",
              carbon: "C50",
              carbonQuality: "T700",
              imcs: 17,
              baseFlex: 62.5,
              topFlex: 76,
              finishing: "Matte Black Spiral Taped",
              ferrule: "Universal Ferrule System",
              maxInsertion: "Maximum 60",
              weight: 2.04,
            },
          },
          mastOnly: {
            handle: "essentials-rdm-c50-constant-curve-370",
            name: "Essentials RDM C50 Constant Curve 370",
            sku: "UF005510370",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_Essential_CC_RDM_TF_609_e4dcc795-6d8f-4627-91ab-b52d88dfd104.png?v=1738391333",
          },
          withBag: {
            handle: "essentials-rdm-c50-constant-curve-370-incl-mastbag",
            name: "Essentials RDM C50 Constant Curve 370 Incl. Mastbag",
            sku: "UF095510370",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_Essential_CC_RDM_TF_609_e4dcc795-6d8f-4627-91ab-b52d88dfd104.png?v=1738391333",
          },
        },
        hd: {
          base: {
            handle: "hd-rdm-c75-constant-curve-370-incl-mastbag",
            name: "HD RDM C75 Constant Curve 370 Incl. Mastbag",
            sku: "UF095710370",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_HD_CC_RDM_TF_594_d69b0a01-335d-40c1-ba79-1f9e2249b554.png?v=1738345094",
            specs: {
              length: 370,
              diameter: "RDM",
              curve: "Constant Curve",
              carbon: "C75",
              carbonQuality: "T700",
              imcs: 17,
              baseFlex: 62.5,
              topFlex: 76,
              finishing: "Matte Black Spiral Taped",
              ferrule: "Universal Ferrule System",
              maxInsertion: "Maximum 60",
              weight: 1.5,
            },
          },
          mastOnly: {
            handle: "hd-rdm-c75-constant-curve-370",
            name: "HD RDM C75 Constant Curve 370",
            sku: "UF005710370",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_HD_CC_RDM_TF_594_d69b0a01-335d-40c1-ba79-1f9e2249b554.png?v=1738345094",
          },
          withBag: {
            handle: "hd-rdm-c75-constant-curve-370-incl-mastbag",
            name: "HD RDM C75 Constant Curve 370 Incl. Mastbag",
            sku: "UF095710370",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_HD_CC_RDM_TF_594_d69b0a01-335d-40c1-ba79-1f9e2249b554.png?v=1738345094",
          },
        },
        elite: {
          base: {
            handle: "elite-rdm-c100-constant-curve-370-incl-mastbag",
            name: "Elite RDM C100 Constant Curve 370 Incl. Mastbag",
            sku: "UF095910370",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/0_1UF_Mast_Elite_CC_RDM_TF_606.png?v=1738343587",
            specs: {
              length: 370,
              diameter: "RDM",
              curve: "Constant Curve",
              carbon: "C100",
              carbonQuality: "T700 & T800",
              imcs: 17,
              baseFlex: 62.5,
              topFlex: 76,
              finishing: "Matte Black Spiral Taped",
              ferrule: "Universal Ferrule System",
              maxInsertion: "Maximum 60",
              weight: 1.36,
            },
          },
          mastOnly: {
            handle: "elite-rdm-c100-constant-curve-370",
            name: "Elite RDM C100 Constant Curve 370",
            sku: "UF005910370",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_Elite_CC_RDM_TF_606_aa4b5e53-f195-405d-8572-d82caa22c2e5.png?v=1738343540",
          },
          withBag: {
            handle: "elite-rdm-c100-constant-curve-370-incl-mastbag",
            name: "Elite RDM C100 Constant Curve 370 Incl. Mastbag",
            sku: "UF095910370",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/0_1UF_Mast_Elite_CC_RDM_TF_606.png?v=1738343587",
          },
        },
      },
      400: {
        essentials: {
          base: {
            handle: "essentials-rdm-c50-constant-curve-400-incl-mastbag",
            name: "Essentials RDM C50 Constant Curve 400 Incl. Mastbag",
            sku: "UF095510400",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_Essential_CC_RDM_TF_609_e4dcc795-6d8f-4627-91ab-b52d88dfd104.png?v=1738391333",
            specs: {
              length: 400,
              diameter: "RDM",
              curve: "Constant Curve",
              carbon: "C50",
              carbonQuality: "T700",
              imcs: 19,
              baseFlex: 62.5,
              topFlex: 76,
              finishing: "Matte Black Spiral Taped",
              ferrule: "Universal Ferrule System",
              maxInsertion: "Maximum 60",
              weight: 2.25,
            },
          },
          mastOnly: {
            handle: "essentials-rdm-c50-constant-curve-400",
            name: "Essentials RDM C50 Constant Curve 400",
            sku: "UF005510400",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_Essential_CC_RDM_TF_609_e4dcc795-6d8f-4627-91ab-b52d88dfd104.png?v=1738391333",
          },
          withBag: {
            handle: "essentials-rdm-c50-constant-curve-400-incl-mastbag",
            name: "Essentials RDM C50 Constant Curve 400 Incl. Mastbag",
            sku: "UF095510400",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_Essential_CC_RDM_TF_609_e4dcc795-6d8f-4627-91ab-b52d88dfd104.png?v=1738391333",
          },
        },
        hd: {
          base: {
            handle: "hd-rdm-c75-constant-curve-400-incl-mastbag",
            name: "HD RDM C75 Constant Curve 400 Incl. Mastbag",
            sku: "UF095710400",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_HD_CC_RDM_TF_594_d69b0a01-335d-40c1-ba79-1f9e2249b554.png?v=1738345094",
            specs: {
              length: 400,
              diameter: "RDM",
              curve: "Constant Curve",
              carbon: "C75",
              carbonQuality: "T700",
              imcs: 19,
              baseFlex: 62.5,
              topFlex: 76,
              finishing: "Matte Black Spiral Taped",
              ferrule: "Universal Ferrule System",
              maxInsertion: "Maximum 60",
              weight: 1.7,
            },
          },
          mastOnly: {
            handle: "hd-rdm-c75-constant-curve-400",
            name: "HD RDM C75 Constant Curve 400",
            sku: "UF005710400",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_HD_CC_RDM_TF_594_d69b0a01-335d-40c1-ba79-1f9e2249b554.png?v=1738345094",
          },
          withBag: {
            handle: "hd-rdm-c75-constant-curve-400-incl-mastbag",
            name: "HD RDM C75 Constant Curve 400 Incl. Mastbag",
            sku: "UF095710400",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_HD_CC_RDM_TF_594_d69b0a01-335d-40c1-ba79-1f9e2249b554.png?v=1738345094",
          },
        },
        elite: {
          base: {
            handle: "elite-rdm-c100-constant-curve-400-incl-mastbag",
            name: "Elite RDM C100 Constant Curve 400 Incl. Mastbag",
            sku: "UF095910400",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/0_1UF_Mast_Elite_CC_RDM_TF_606_1cd81173-8ca1-4689-bd29-fa1fdfba4b86.png?v=1738343593",
            specs: {
              length: 400,
              diameter: "RDM",
              curve: "Constant Curve",
              carbon: "C100",
              carbonQuality: "T700 & T800",
              imcs: 19,
              baseFlex: 62.5,
              topFlex: 76,
              finishing: "Matte Black Spiral Taped",
              ferrule: "Universal Ferrule System",
              maxInsertion: "Maximum 60",
              weight: 1.55,
            },
          },
          mastOnly: {
            handle: "elite-rdm-c100-constant-curve-400",
            name: "Elite RDM C100 Constant Curve 400",
            sku: "UF005910400",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/0_1UF_Mast_Elite_CC_RDM_TF_606_1cd81173-8ca1-4689-bd29-fa1fdfba4b86.png?v=1738343593",
          },
          withBag: {
            handle: "elite-rdm-c100-constant-curve-400-incl-mastbag",
            name: "Elite RDM C100 Constant Curve 400 Incl. Mastbag",
            sku: "UF095910400",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/0_1UF_Mast_Elite_CC_RDM_TF_606_1cd81173-8ca1-4689-bd29-fa1fdfba4b86.png?v=1738343593",
          },
        },
      },
      430: {
        essentials: {
          base: {
            handle: "essentials-rdm-c50-constant-curve-430-incl-mastbag",
            name: "Essentials RDM C50 Constant Curve 430 Incl. Mastbag",
            sku: "UF095510430",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_Essential_CC_RDM_TF_609_e4dcc795-6d8f-4627-91ab-b52d88dfd104.png?v=1738391333",
            specs: {
              length: 430,
              diameter: "RDM",
              curve: "Constant Curve",
              carbon: "C50",
              carbonQuality: "T700",
              imcs: 21,
              baseFlex: 62.5,
              topFlex: 76,
              finishing: "Matte Black Spiral Taped",
              ferrule: "Universal Ferrule System",
              maxInsertion: "Maximum 60",
              weight: 2.43,
            },
          },
          mastOnly: {
            handle: "essentials-rdm-c50-constant-curve-430",
            name: "Essentials RDM C50 Constant Curve 430",
            sku: "UF005510430",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_Essential_CC_RDM_TF_609_e4dcc795-6d8f-4627-91ab-b52d88dfd104.png?v=1738391333",
          },
          withBag: {
            handle: "essentials-rdm-c50-constant-curve-430-incl-mastbag",
            name: "Essentials RDM C50 Constant Curve 430 Incl. Mastbag",
            sku: "UF095510430",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_Essential_CC_RDM_TF_609_e4dcc795-6d8f-4627-91ab-b52d88dfd104.png?v=1738391333",
          },
        },
        hd: {
          base: {
            handle: "hd-rdm-c75-constant-curve-430-incl-mastbag",
            name: "HD RDM C75 Constant Curve 430 Incl. Mastbag",
            sku: "UF095710430",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_HD_CC_RDM_TF_594_d69b0a01-335d-40c1-ba79-1f9e2249b554.png?v=1738345094",
            specs: {
              length: 430,
              diameter: "RDM",
              curve: "Constant Curve",
              carbon: "C75",
              carbonQuality: "T700",
              imcs: 21,
              baseFlex: 62.5,
              topFlex: 76,
              finishing: "Matte Black Spiral Taped",
              ferrule: "Universal Ferrule System",
              maxInsertion: "Maximum 60",
              weight: 1.89,
            },
          },
          mastOnly: {
            handle: "hd-rdm-c75-constant-curve-430",
            name: "HD RDM C75 Constant Curve 430",
            sku: "UF005710430",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_HD_CC_RDM_TF_594_d69b0a01-335d-40c1-ba79-1f9e2249b554.png?v=1738345094",
          },
          withBag: {
            handle: "hd-rdm-c75-constant-curve-430-incl-mastbag",
            name: "HD RDM C75 Constant Curve 430 Incl. Mastbag",
            sku: "UF095710430",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_HD_CC_RDM_TF_594_d69b0a01-335d-40c1-ba79-1f9e2249b554.png?v=1738345094",
          },
        },
        elite: {
          base: {
            handle: "elite-rdm-c100-constant-curve-430-incl-mastbag",
            name: "Elite RDM C100 Constant Curve 430 Incl. Mastbag",
            sku: "UF095910430",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/0_1UF_Mast_Elite_CC_RDM_TF_606_1cd81173-8ca1-4689-bd29-fa1fdfba4b86.png?v=1738343593",
            specs: {
              length: 430,
              diameter: "RDM",
              curve: "Constant Curve",
              carbon: "C100",
              carbonQuality: "T700 & T800",
              imcs: 21,
              baseFlex: 62.5,
              topFlex: 76,
              finishing: "Matte Black Spiral Taped",
              ferrule: "Universal Ferrule System",
              maxInsertion: "Maximum 60",
              weight: 1.75,
            },
          },
          mastOnly: {
            handle: "elite-rdm-c100-constant-curve-430",
            name: "Elite RDM C100 Constant Curve 430",
            sku: "UF005910430",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/0_1UF_Mast_Elite_CC_RDM_TF_606_1cd81173-8ca1-4689-bd29-fa1fdfba4b86.png?v=1738343593",
          },
          withBag: {
            handle: "elite-rdm-c100-constant-curve-430-incl-mastbag",
            name: "Elite RDM C100 Constant Curve 430 Incl. Mastbag",
            sku: "UF095910430",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/0_1UF_Mast_Elite_CC_RDM_TF_606_1cd81173-8ca1-4689-bd29-fa1fdfba4b86.png?v=1738343593",
          },
        },
      },
      460: {
        essentials: {
          base: {
            handle: "essentials-rdm-c50-constant-curve-460-incl-mastbag",
            name: "Essentials RDM C50 Constant Curve 460 Incl. Mastbag",
            sku: "UF095510460",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_Essential_CC_RDM_TF_609_e4dcc795-6d8f-4627-91ab-b52d88dfd104.png?v=1738391333",
            specs: {
              length: 460,
              diameter: "RDM",
              curve: "Constant Curve",
              carbon: "C50",
              carbonQuality: "T700",
              imcs: 25,
              baseFlex: 62.5,
              topFlex: 76,
              finishing: "Matte Black Spiral Taped",
              ferrule: "Universal Ferrule System",
              maxInsertion: "Maximum 60",
              weight: 2.75,
            },
          },
          mastOnly: {
            handle: "essentials-rdm-c50-constant-curve-460",
            name: "Essentials RDM C50 Constant Curve 460",
            sku: "UF005510460",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_Essential_CC_RDM_TF_609_e4dcc795-6d8f-4627-91ab-b52d88dfd104.png?v=1738391333",
          },
          withBag: {
            handle: "essentials-rdm-c50-constant-curve-460-incl-mastbag",
            name: "Essentials RDM C50 Constant Curve 460 Incl. Mastbag",
            sku: "UF095510460",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_Essential_CC_RDM_TF_609_e4dcc795-6d8f-4627-91ab-b52d88dfd104.png?v=1738391333",
          },
        },
        hd: {
          base: {
            handle: "hd-rdm-c75-constant-curve-460-incl-mastbag",
            name: "HD RDM C75 Constant Curve 460 Incl. Mastbag",
            sku: "UF095710460",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_HD_CC_RDM_TF_594_d69b0a01-335d-40c1-ba79-1f9e2249b554.png?v=1738345094",
            specs: {
              length: 460,
              diameter: "RDM",
              curve: "Constant Curve",
              carbon: "C75",
              carbonQuality: "T700",
              imcs: 25,
              baseFlex: 62.5,
              topFlex: 76,
              finishing: "Matte Black Spiral Taped",
              ferrule: "Universal Ferrule System",
              maxInsertion: "Maximum 60",
              weight: 2.18,
            },
          },
          mastOnly: {
            handle: "hd-rdm-c75-constant-curve-460",
            name: "HD RDM C75 Constant Curve 460",
            sku: "UF005710460",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_HD_CC_RDM_TF_594_d69b0a01-335d-40c1-ba79-1f9e2249b554.png?v=1738345094",
          },
          withBag: {
            handle: "hd-rdm-c75-constant-curve-460-incl-mastbag",
            name: "HD RDM C75 Constant Curve 460 Incl. Mastbag",
            sku: "UF095710460",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_HD_CC_RDM_TF_594_d69b0a01-335d-40c1-ba79-1f9e2249b554.png?v=1738345094",
          },
        },
        elite: {
          base: {
            handle: "elite-rdm-c100-constant-curve-460-incl-mastbag",
            name: "Elite RDM C100 Constant Curve 460 Incl. Mastbag",
            sku: "UF095910460",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/0_1UF_Mast_Elite_CC_RDM_TF_606_1cd81173-8ca1-4689-bd29-fa1fdfba4b86.png?v=1738343593",
            specs: {
              length: 460,
              diameter: "RDM",
              curve: "Constant Curve",
              carbon: "C100",
              carbonQuality: "T700 & T800",
              imcs: 25,
              baseFlex: 62.5,
              topFlex: 76,
              finishing: "Matte Black Spiral Taped",
              ferrule: "Universal Ferrule System",
              maxInsertion: "Maximum 60",
              weight: 1.94,
            },
          },
          mastOnly: {
            handle: "elite-rdm-c100-constant-curve-460",
            name: "Elite RDM C100 Constant Curve 460",
            sku: "UF005910460",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/0_1UF_Mast_Elite_CC_RDM_TF_606_1cd81173-8ca1-4689-bd29-fa1fdfba4b86.png?v=1738343593",
          },
          withBag: {
            handle: "elite-rdm-c100-constant-curve-460-incl-mastbag",
            name: "Elite RDM C100 Constant Curve 460 Incl. Mastbag",
            sku: "UF095910460",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/0_1UF_Mast_Elite_CC_RDM_TF_606_1cd81173-8ca1-4689-bd29-fa1fdfba4b86.png?v=1738343593",
          },
        },
      },
    },
    SDM: {
      400: {
        essentials: {
          base: {
            handle: "essentials-sdm-c50-constant-curve-400-incl-mastbag",
            name: "Essentials SDM C50 Constant Curve 400 Incl. Mastbag",
            sku: "UF096010400",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_Essential_CC_SDM_TF_617_7e461af3-e88c-434b-a5e2-f649fadd4890.png?v=1738391773",
            specs: {
              length: 400,
              diameter: "SDM",
              curve: "Constant Curve",
              carbon: "C50",
              carbonQuality: "T700",
              imcs: 19,
              baseFlex: 62.5,
              topFlex: 76,
              finishing: "Matte Black Spiral Taped",
              ferrule: "Universal Ferrule System",
              maxInsertion: "Maximum 45",
              weight: 2.18,
            },
          },
          mastOnly: {
            handle: "essentials-sdm-c50-constant-curve-400",
            name: "Essentials SDM C50 Constant Curve 400",
            sku: "UF006010400",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_Essential_FL_RDM_TF_610_11c9930f-dea5-4823-961f-d38eb77aa205.png?v=1738391735",
          },
          withBag: {
            handle: "essentials-sdm-c50-constant-curve-400-incl-mastbag",
            name: "Essentials SDM C50 Constant Curve 400 Incl. Mastbag",
            sku: "UF096010400",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_Essential_CC_SDM_TF_617_7e461af3-e88c-434b-a5e2-f649fadd4890.png?v=1738391773",
          },
        },
        hd: {
          base: {
            handle: "hd-sdm-c75-constant-curve-400-incl-mastbag",
            name: "HD SDM C75 Constant Curve 400 Incl. Mastbag",
            sku: "UF096210400",
            image: "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_HD_CC_SDM_TF_624.png?v=1738390263",
            specs: {
              length: 400,
              diameter: "SDM",
              curve: "Constant Curve",
              carbon: "C75",
              carbonQuality: "T700",
              imcs: 19,
              baseFlex: 62.5,
              topFlex: 76,
              finishing: "Matte Black Spiral Taped",
              ferrule: "Universal Ferrule System",
              maxInsertion: "Maximum 45",
              weight: 1.65,
            },
          },
          mastOnly: {
            handle: "hd-sdm-c75-constant-curve-400",
            name: "HD SDM C75 Constant Curve 400",
            sku: "UF006210400",
            image: "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_HD_CC_SDM_TF_624.png?v=1738390263",
          },
          withBag: {
            handle: "hd-sdm-c75-constant-curve-400-incl-mastbag",
            name: "HD SDM C75 Constant Curve 400 Incl. Mastbag",
            sku: "UF096210400",
            image: "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_HD_CC_SDM_TF_624.png?v=1738390263",
          },
        },
        elite: {
          base: {
            handle: "elite-sdm-c100-constant-curve-400-incl-mastbag",
            name: "Elite SDM C100 Constant Curve 400 Incl. Mastbag",
            sku: "UF096410400",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_Elite_CC_SDM_TF_628_780563b0-3900-423c-b976-294ffb3226f7.png?v=1738344097",
            specs: {
              length: 400,
              diameter: "SDM",
              curve: "Constant Curve",
              carbon: "C100",
              carbonQuality: "T700 & T800",
              imcs: 19,
              baseFlex: 62.5,
              topFlex: 76,
              finishing: "Matte Black Spiral Taped",
              ferrule: "Universal Ferrule System",
              maxInsertion: "Maximum 45",
              weight: 1.46,
            },
          },
          mastOnly: {
            handle: "elite-sdm-c100-constant-curve-400",
            name: "Elite SDM C100 Constant Curve 400",
            sku: "UF006410400",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_Elite_CC_SDM_TF_628_780563b0-3900-423c-b976-294ffb3226f7.png?v=1738344097",
          },
          withBag: {
            handle: "elite-sdm-c100-constant-curve-400-incl-mastbag",
            name: "Elite SDM C100 Constant Curve 400 Incl. Mastbag",
            sku: "UF096410400",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_Elite_CC_SDM_TF_628_780563b0-3900-423c-b976-294ffb3226f7.png?v=1738344097",
          },
        },
      },
      430: {
        essentials: {
          base: {
            handle: "essentials-sdm-c50-constant-curve-430-incl-mastbag",
            name: "Essentials SDM C50 Constant Curve 430 Incl. Mastbag",
            sku: "UF096010430",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_Essential_CC_SDM_TF_617_7e461af3-e88c-434b-a5e2-f649fadd4890.png?v=1738391773",
            specs: {
              length: 430,
              diameter: "SDM",
              curve: "Constant Curve",
              carbon: "C50",
              carbonQuality: "T700",
              imcs: 21,
              baseFlex: 62.5,
              topFlex: 76,
              finishing: "Matte Black Spiral Taped",
              ferrule: "Universal Ferrule System",
              maxInsertion: "Maximum 45",
              weight: 2.33,
            },
          },
          mastOnly: {
            handle: "essentials-sdm-c50-constant-curve-430",
            name: "Essentials SDM C50 Constant Curve 430",
            sku: "UF006010430",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_Essential_CC_SDM_TF_617_7e461af3-e88c-434b-a5e2-f649fadd4890.png?v=1738391773",
          },
          withBag: {
            handle: "essentials-sdm-c50-constant-curve-430-incl-mastbag",
            name: "Essentials SDM C50 Constant Curve 430 Incl. Mastbag",
            sku: "UF096010430",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_Essential_CC_SDM_TF_617_7e461af3-e88c-434b-a5e2-f649fadd4890.png?v=1738391773",
          },
        },
        hd: {
          base: {
            handle: "hd-sdm-c75-constant-curve-430-incl-mastbag",
            name: "HD SDM C75 Constant Curve 430 Incl. Mastbag",
            sku: "UF096210430",
            image: "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_HD_CC_SDM_TF_624.png?v=1738390263",
            specs: {
              length: 430,
              diameter: "SDM",
              curve: "Constant Curve",
              carbon: "C75",
              carbonQuality: "T700",
              imcs: 21,
              baseFlex: 62.5,
              topFlex: 76,
              finishing: "Matte Black Spiral Taped",
              ferrule: "Universal Ferrule System",
              maxInsertion: "Maximum 45",
              weight: 1.84,
            },
          },
          mastOnly: {
            handle: "hd-sdm-c75-constant-curve-430",
            name: "HD SDM C75 Constant Curve 430",
            sku: "UF006210430",
            image: "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_HD_CC_SDM_TF_624.png?v=1738390263",
          },
          withBag: {
            handle: "hd-sdm-c75-constant-curve-430-incl-mastbag",
            name: "HD SDM C75 Constant Curve 430 Incl. Mastbag",
            sku: "UF096210430",
            image: "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_HD_CC_SDM_TF_624.png?v=1738390263",
          },
        },
        elite: {
          base: {
            handle: "elite-sdm-c100-constant-curve-430-incl-mastbag",
            name: "Elite SDM C100 Constant Curve 430 Incl. Mastbag",
            sku: "UF096410430",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_Elite_CC_SDM_TF_628_780563b0-3900-423c-b976-294ffb3226f7.png?v=1738344097",
            specs: {
              length: 430,
              diameter: "SDM",
              curve: "Constant Curve",
              carbon: "C100",
              carbonQuality: "T700 & T800",
              imcs: 21,
              baseFlex: 62.5,
              topFlex: 76,
              finishing: "Matte Black Spiral Taped",
              ferrule: "Universal Ferrule System",
              maxInsertion: "Maximum 45",
              weight: 1.65,
            },
          },
          mastOnly: {
            handle: "elite-sdm-c100-constant-curve-430",
            name: "Elite SDM C100 Constant Curve 430",
            sku: "UF006410430",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_Elite_CC_SDM_TF_628_780563b0-3900-423c-b976-294ffb3226f7.png?v=1738344097",
          },
          withBag: {
            handle: "elite-sdm-c100-constant-curve-430-incl-mastbag",
            name: "Elite SDM C100 Constant Curve 430 Incl. Mastbag",
            sku: "UF096410430",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_Elite_CC_SDM_TF_628_780563b0-3900-423c-b976-294ffb3226f7.png?v=1738344097",
          },
        },
      },
      460: {
        essentials: {
          base: {
            handle: "essentials-sdm-c50-constant-curve-460-incl-mastbag",
            name: "Essentials SDM C50 Constant Curve 460 Incl. Mastbag",
            sku: "UF096010460",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_Essential_CC_SDM_TF_617_7e461af3-e88c-434b-a5e2-f649fadd4890.png?v=1738391773",
            specs: {
              length: 460,
              diameter: "SDM",
              curve: "Constant Curve",
              carbon: "C50",
              carbonQuality: "T700",
              imcs: 25,
              baseFlex: 62.5,
              topFlex: 76,
              finishing: "Matte Black Spiral Taped",
              ferrule: "Universal Ferrule System",
              maxInsertion: "Maximum 45",
              weight: 2.62,
            },
          },
          mastOnly: {
            handle: "essentials-sdm-c50-constant-curve-460",
            name: "Essentials SDM C50 Constant Curve 460",
            sku: "UF006010460",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_Essential_CC_SDM_TF_617_7e461af3-e88c-434b-a5e2-f649fadd4890.png?v=1738391773",
          },
          withBag: {
            handle: "essentials-sdm-c50-constant-curve-460-incl-mastbag",
            name: "Essentials SDM C50 Constant Curve 460 Incl. Mastbag",
            sku: "UF096010460",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_Essential_CC_SDM_TF_617_7e461af3-e88c-434b-a5e2-f649fadd4890.png?v=1738391773",
          },
        },
        hd: {
          base: {
            handle: "hd-sdm-c75-constant-curve-460-incl-mastbag",
            name: "HD SDM C75 Constant Curve 460 Incl. Mastbag",
            sku: "UF096210460",
            image: "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_HD_CC_SDM_TF_624.png?v=1738390263",
            specs: {
              length: 460,
              diameter: "SDM",
              curve: "Constant Curve",
              carbon: "C75",
              carbonQuality: "T700",
              imcs: 25,
              baseFlex: 62.5,
              topFlex: 76,
              finishing: "Matte Black Spiral Taped",
              ferrule: "Universal Ferrule System",
              maxInsertion: "Maximum 45",
              weight: 2.14,
            },
          },
          mastOnly: {
            handle: "hd-sdm-c75-constant-curve-460",
            name: "HD SDM C75 Constant Curve 460",
            sku: "UF006210460",
            image: "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_HD_CC_SDM_TF_624.png?v=1738390263",
          },
          withBag: {
            handle: "hd-sdm-c75-constant-curve-460-incl-mastbag",
            name: "HD SDM C75 Constant Curve 460 Incl. Mastbag",
            sku: "UF096210460",
            image: "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_HD_CC_SDM_TF_624.png?v=1738390263",
          },
        },
        elite: {
          base: {
            handle: "elite-sdm-c100-constant-curve-460-incl-mastbag",
            name: "Elite SDM C100 Constant Curve 460 Incl. Mastbag",
            sku: "UF096410460",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_Elite_CC_SDM_TF_628_780563b0-3900-423c-b976-294ffb3226f7.png?v=1738344097",
            specs: {
              length: 460,
              diameter: "SDM",
              curve: "Constant Curve",
              carbon: "C100",
              carbonQuality: "T700 & T800",
              imcs: 25,
              baseFlex: 62.5,
              topFlex: 76,
              finishing: "Matte Black Spiral Taped",
              ferrule: "Universal Ferrule System",
              maxInsertion: "Maximum 45",
              weight: 1.89,
            },
          },
          mastOnly: {
            handle: "elite-sdm-c100-constant-curve-460",
            name: "Elite SDM C100 Constant Curve 460",
            sku: "UF006410460",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_Elite_CC_SDM_TF_628_780563b0-3900-423c-b976-294ffb3226f7.png?v=1738344097",
          },
          withBag: {
            handle: "elite-sdm-c100-constant-curve-460-incl-mastbag",
            name: "Elite SDM C100 Constant Curve 460 Incl. Mastbag",
            sku: "UF096410460",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_Elite_CC_SDM_TF_628_780563b0-3900-423c-b976-294ffb3226f7.png?v=1738344097",
          },
        },
      },
      490: {
        essentials: {
          base: {
            handle: "essentials-sdm-c50-constant-curve-490-incl-mastbag",
            name: "Essentials SDM C50 Constant Curve 490 Incl. Mastbag",
            sku: "UF096010490",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_Essential_CC_SDM_TF_617_7e461af3-e88c-434b-a5e2-f649fadd4890.png?v=1738391773",
            specs: {
              length: 490,
              diameter: "SDM",
              curve: "Constant Curve",
              carbon: "C50",
              carbonQuality: "T700",
              imcs: 29,
              baseFlex: 62.5,
              topFlex: 76,
              finishing: "Matte Black Spiral Taped",
              ferrule: "Universal Ferrule System",
              maxInsertion: "Maximum 45",
              weight: 2.91,
            },
          },
          mastOnly: {
            handle: "essentials-sdm-c50-constant-curve-490",
            name: "Essentials SDM C50 Constant Curve 490",
            sku: "UF006010490",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_Essential_CC_SDM_TF_617_7e461af3-e88c-434b-a5e2-f649fadd4890.png?v=1738391773",
          },
          withBag: {
            handle: "essentials-sdm-c50-constant-curve-490-incl-mastbag",
            name: "Essentials SDM C50 Constant Curve 490 Incl. Mastbag",
            sku: "UF096010490",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_Essential_CC_SDM_TF_617_7e461af3-e88c-434b-a5e2-f649fadd4890.png?v=1738391773",
          },
        },
        hd: {
          base: {
            handle: "hd-sdm-c75-constant-curve-490-incl-mastbag",
            name: "HD SDM C75 Constant Curve 490 Incl. Mastbag",
            sku: "UF096210490",
            image: "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_HD_CC_SDM_TF_624.png?v=1738390263",
            specs: {
              length: 490,
              diameter: "SDM",
              curve: "Constant Curve",
              carbon: "C75",
              carbonQuality: "T700",
              imcs: 29,
              baseFlex: 62.5,
              topFlex: 76,
              finishing: "Matte Black Spiral Taped",
              ferrule: "Universal Ferrule System",
              maxInsertion: "Maximum 60",
              weight: 2.43,
            },
          },
          mastOnly: {
            handle: "hd-sdm-c75-constant-curve-490",
            name: "HD SDM C75 Constant Curve 490",
            sku: "UF006210490",
            image: "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_HD_CC_SDM_TF_624.png?v=1738390263",
          },
          withBag: {
            handle: "hd-sdm-c75-constant-curve-490-incl-mastbag",
            name: "HD SDM C75 Constant Curve 490 Incl. Mastbag",
            sku: "UF096210490",
            image: "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_HD_CC_SDM_TF_624.png?v=1738390263",
          },
        },
        elite: {
          base: {
            handle: "elite-sdm-c100-constant-curve-490-incl-mastbag",
            name: "Elite SDM C100 Constant Curve 490 Incl. Mastbag",
            sku: "UF096410490",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_Elite_CC_SDM_TF_628_780563b0-3900-423c-b976-294ffb3226f7.png?v=1738344097",
            specs: {
              length: 490,
              diameter: "SDM",
              curve: "Constant Curve",
              carbon: "C100",
              carbonQuality: "T700 & T800",
              imcs: 29,
              baseFlex: 62.5,
              topFlex: 76,
              finishing: "Matte Black Spiral Taped",
              ferrule: "Universal Ferrule System",
              maxInsertion: "Maximum 60",
              weight: 2.14,
            },
          },
          mastOnly: {
            handle: "elite-sdm-c100-constant-curve-490",
            name: "Elite SDM C100 Constant Curve 490",
            sku: "UF006410490",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_Elite_CC_SDM_TF_628_780563b0-3900-423c-b976-294ffb3226f7.png?v=1738344097",
          },
          withBag: {
            handle: "elite-sdm-c100-constant-curve-490-incl-mastbag",
            name: "Elite SDM C100 Constant Curve 490 Incl. Mastbag",
            sku: "UF096410490",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_Elite_CC_SDM_TF_628_780563b0-3900-423c-b976-294ffb3226f7.png?v=1738344097",
          },
        },
      },
      520: {
        hd: {
          base: {
            handle: "hd-sdm-c75-constant-curve-520-incl-mastbag",
            name: "HD SDM C75 Constant Curve 520 Incl. Mastbag",
            sku: "UF096210520",
            image: "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_HD_CC_SDM_TF_624.png?v=1738390263",
            specs: {
              length: 520,
              diameter: "SDM",
              curve: "Constant Curve",
              carbon: "C75",
              carbonQuality: "T700",
              imcs: 33,
              baseFlex: 62.5,
              topFlex: 76,
              finishing: "Matte Black Spiral Taped",
              ferrule: "Universal Ferrule System",
              maxInsertion: "Maximum 60",
              weight: 2.72,
            },
          },
          mastOnly: {
            handle: "hd-sdm-c75-constant-curve-520",
            name: "HD SDM C75 Constant Curve 520",
            sku: "UF006210520",
            image: "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_HD_CC_SDM_TF_624.png?v=1738390263",
          },
          withBag: {
            handle: "hd-sdm-c75-constant-curve-520-incl-mastbag",
            name: "HD SDM C75 Constant Curve 520 Incl. Mastbag",
            sku: "UF096210520",
            image: "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_HD_CC_SDM_TF_624.png?v=1738390263",
          },
        },
      },
    },
  },
  fl: {
    RDM: {
      340: {
        essentials: {
          base: {
            handle: "essentials-rdm-c50-constant-fl-curve-340-incl-mastbag",
            name: "Essentials RDM C50 Constant FL Curve 340 Incl. Mastbag",
            sku: "UF095520340",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_Essential_FL_RDM_TF_610_11c9930f-dea5-4823-961f-d38eb77aa205.png?v=1738391735",
            specs: {
              length: 340,
              diameter: "RDM",
              curve: "Constant FL Curve",
              carbon: "C50",
              carbonQuality: "T700",
              imcs: 14,
              baseFlex: 62,
              topFlex: 77,
              finishing: "Matte Black Spiral Taped",
              ferrule: "Universal Ferrule System",
              maxInsertion: "Maximum 60",
              weight: 1.75,
            },
          },
          mastOnly: {
            handle: "essentials-rdm-c50-constant-fl-curve-340",
            name: "Essentials RDM C50 Constant FL Curve 340",
            sku: "UF005520340",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_Essential_FL_RDM_TF_610_11c9930f-dea5-4823-961f-d38eb77aa205.png?v=1738391735",
          },
          withBag: {
            handle: "essentials-rdm-c50-constant-fl-curve-340-incl-mastbag",
            name: "Essentials RDM C50 Constant FL Curve 340 Incl. Mastbag",
            sku: "UF095520340",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_Essential_FL_RDM_TF_610_11c9930f-dea5-4823-961f-d38eb77aa205.png?v=1738391735",
          },
        },
        hd: {
          base: {
            handle: "hd-rdm-c75-constant-fl-curve-340-incl-mastbag",
            name: "HD RDM C75 Constant FL Curve 340 Incl. Mastbag",
            sku: "UF095720340",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_HD_FL_RDM_TF_598_6585d2c3-ed8b-4fb4-81e9-7ddf559fb5a9.png?v=1738345328",
            specs: {
              length: 340,
              diameter: "RDM",
              curve: "Constant FL Curve",
              carbon: "C75",
              carbonQuality: "T700",
              imcs: 14,
              baseFlex: 62,
              topFlex: 77,
              finishing: "Matte Black Spiral Taped",
              ferrule: "Universal Ferrule System",
              maxInsertion: "Maximum 60",
              weight: 1.36,
            },
          },
          mastOnly: {
            handle: "hd-rdm-c75-constant-fl-curve-340",
            name: "HD RDM C75 Constant FL Curve 340",
            sku: "UF005720340",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_HD_FL_RDM_TF_598_6585d2c3-ed8b-4fb4-81e9-7ddf559fb5a9.png?v=1738345328",
          },
          withBag: {
            handle: "hd-rdm-c75-constant-fl-curve-340-incl-mastbag",
            name: "HD RDM C75 Constant FL Curve 340 Incl. Mastbag",
            sku: "UF095720340",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_HD_FL_RDM_TF_598_6585d2c3-ed8b-4fb4-81e9-7ddf559fb5a9.png?v=1738345328",
          },
        },
        elite: {
          base: {
            handle: "elite-rdm-c100-constant-fl-curve-340-incl-mastbag",
            name: "Elite RDM C100 Constant FL Curve 340 Incl. Mastbag",
            sku: "UF095920340",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/01_UF_Mast_Elite_FL_RDM_TF_605_3c012909-957d-4416-9255-3a9638db2bbf.png?v=1738343835",
            specs: {
              length: 340,
              diameter: "RDM",
              curve: "Constant FL Curve",
              carbon: "C100",
              carbonQuality: "T700 & T800",
              imcs: 14,
              baseFlex: 62,
              topFlex: 77,
              finishing: "Matte Black Spiral Taped",
              ferrule: "Universal Ferrule System",
              maxInsertion: "Maximum 60",
              weight: 1.21,
            },
          },
          mastOnly: {
            handle: "elite-rdm-c100-constant-fl-curve-340",
            name: "Elite RDM C100 Constant FL Curve 340",
            sku: "UF005920340",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/01_UF_Mast_Elite_FL_RDM_TF_605_3c012909-957d-4416-9255-3a9638db2bbf.png?v=1738343835",
          },
          withBag: {
            handle: "elite-rdm-c100-constant-fl-curve-340-incl-mastbag",
            name: "Elite RDM C100 Constant FL Curve 340 Incl. Mastbag",
            sku: "UF095920340",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/01_UF_Mast_Elite_FL_RDM_TF_605_3c012909-957d-4416-9255-3a9638db2bbf.png?v=1738343835",
          },
        },
      },
      370: {
        essentials: {
          base: {
            handle: "essentials-rdm-c50-constant-fl-curve-370-incl-mastbag",
            name: "Essentials RDM C50 Constant FL Curve 370 Incl. Mastbag",
            sku: "UF095520370",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_Essential_FL_RDM_TF_610_11c9930f-dea5-4823-961f-d38eb77aa205.png?v=1738391735",
            specs: {
              length: 370,
              diameter: "RDM",
              curve: "Constant FL Curve",
              carbon: "C50",
              carbonQuality: "T700",
              imcs: 17,
              baseFlex: 62,
              topFlex: 77,
              finishing: "Matte Black Spiral Taped",
              ferrule: "Universal Ferrule System",
              maxInsertion: "Maximum 60",
              weight: 2.04,
            },
          },
          mastOnly: {
            handle: "essentials-rdm-c50-constant-fl-curve-370",
            name: "Essentials RDM C50 Constant FL Curve 370",
            sku: "UF005520370",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_Essential_FL_RDM_TF_610_11c9930f-dea5-4823-961f-d38eb77aa205.png?v=1738391735",
          },
          withBag: {
            handle: "essentials-rdm-c50-constant-fl-curve-370-incl-mastbag",
            name: "Essentials RDM C50 Constant FL Curve 370 Incl. Mastbag",
            sku: "UF095520370",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_Essential_FL_RDM_TF_610_11c9930f-dea5-4823-961f-d38eb77aa205.png?v=1738391735",
          },
        },
        hd: {
          base: {
            handle: "hd-rdm-c75-constant-fl-curve-370-incl-mastbag",
            name: "HD RDM C75 Constant FL Curve 370 Incl. Mastbag",
            sku: "UF095720370",
            image: null,
            specs: {
              length: 370,
              diameter: "RDM",
              curve: "Constant FL Curve",
              carbon: "C75",
              carbonQuality: "T700",
              imcs: 17,
              baseFlex: 62,
              topFlex: 77,
              finishing: "Matte Black Spiral Taped",
              ferrule: "Universal Ferrule System",
              maxInsertion: "Maximum 60",
              weight: 1.5,
            },
          },
          mastOnly: {
            handle: "hd-rdm-c75-constant-fl-curve-370",
            name: "HD RDM C75 Constant FL Curve 370",
            sku: "UF005720370",
            image: null,
          },
          withBag: {
            handle: "hd-rdm-c75-constant-fl-curve-370-incl-mastbag",
            name: "HD RDM C75 Constant FL Curve 370 Incl. Mastbag",
            sku: "UF095720370",
            image: null,
          },
        },
        elite: {
          base: {
            handle: "elite-rdm-c100-constant-fl-curve-370-incl-mastbag",
            name: "Elite RDM C100 Constant FL Curve 370 Incl. Mastbag",
            sku: "UF095920370",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/01_UF_Mast_Elite_FL_RDM_TF_605_3c012909-957d-4416-9255-3a9638db2bbf.png?v=1738343835",
            specs: {
              length: 370,
              diameter: "RDM",
              curve: "Constant FL Curve",
              carbon: "C100",
              carbonQuality: "T700 & T800",
              imcs: 17,
              baseFlex: 62,
              topFlex: 77,
              finishing: "Matte Black Spiral Taped",
              ferrule: "Universal Ferrule System",
              maxInsertion: "Maximum 60",
              weight: 1.36,
            },
          },
          mastOnly: {
            handle: "elite-rdm-c100-constant-fl-curve-370",
            name: "Elite RDM C100 Constant FL Curve 370",
            sku: "UF005920370",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/01_UF_Mast_Elite_FL_RDM_TF_605_3c012909-957d-4416-9255-3a9638db2bbf.png?v=1738343835",
          },
          withBag: {
            handle: "elite-rdm-c100-constant-fl-curve-370-incl-mastbag",
            name: "Elite RDM C100 Constant FL Curve 370 Incl. Mastbag",
            sku: "UF095920370",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/01_UF_Mast_Elite_FL_RDM_TF_605_3c012909-957d-4416-9255-3a9638db2bbf.png?v=1738343835",
          },
        },
      },
      400: {
        essentials: {
          base: {
            handle: "essentials-rdm-c50-constant-fl-curve-400-incl-mastbag",
            name: "Essentials RDM C50 Constant FL Curve 400 Incl. Mastbag",
            sku: "UF095520400",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_Essential_FL_RDM_TF_610_11c9930f-dea5-4823-961f-d38eb77aa205.png?v=1738391735",
            specs: {
              length: 400,
              diameter: "RDM",
              curve: "Constant FL Curve",
              carbon: "C50",
              carbonQuality: "T700",
              imcs: 19,
              baseFlex: 62,
              topFlex: 77,
              finishing: "Matte Black Spiral Taped",
              ferrule: "Universal Ferrule System",
              maxInsertion: "Maximum 60",
              weight: 2.23,
            },
          },
          mastOnly: {
            handle: "essentials-rdm-c50-constant-fl-curve-400",
            name: "Essentials RDM C50 Constant FL Curve 400",
            sku: "UF005520400",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_Essential_FL_RDM_TF_610_11c9930f-dea5-4823-961f-d38eb77aa205.png?v=1738391735",
          },
          withBag: {
            handle: "essentials-rdm-c50-constant-fl-curve-400-incl-mastbag",
            name: "Essentials RDM C50 Constant FL Curve 400 Incl. Mastbag",
            sku: "UF095520400",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_Essential_FL_RDM_TF_610_11c9930f-dea5-4823-961f-d38eb77aa205.png?v=1738391735",
          },
        },
        hd: {
          base: {
            handle: "hd-rdm-c75-constant-fl-curve-400-incl-mastbag",
            name: "HD RDM C75 Constant FL Curve 400 Incl. Mastbag",
            sku: "UF095720400",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_HD_FL_RDM_TF_598_6585d2c3-ed8b-4fb4-81e9-7ddf559fb5a9.png?v=1738345328",
            specs: {
              length: 400,
              diameter: "RDM",
              curve: "Constant FL Curve",
              carbon: "C75",
              carbonQuality: "T700",
              imcs: 19,
              baseFlex: 62,
              topFlex: 77,
              finishing: "Matte Black Spiral Taped",
              ferrule: "Universal Ferrule System",
              maxInsertion: "Maximum 60",
              weight: 1.7,
            },
          },
          mastOnly: {
            handle: "hd-rdm-c75-constant-fl-curve-400",
            name: "HD RDM C75 Constant FL Curve 400",
            sku: "UF005720400",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_HD_FL_RDM_TF_598_6585d2c3-ed8b-4fb4-81e9-7ddf559fb5a9.png?v=1738345328",
          },
          withBag: {
            handle: "hd-rdm-c75-constant-fl-curve-400-incl-mastbag",
            name: "HD RDM C75 Constant FL Curve 400 Incl. Mastbag",
            sku: "UF095720400",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_HD_FL_RDM_TF_598_6585d2c3-ed8b-4fb4-81e9-7ddf559fb5a9.png?v=1738345328",
          },
        },
        elite: {
          base: {
            handle: "elite-rdm-c100-constant-fl-curve-400-incl-mastbag",
            name: "Elite RDM C100 Constant FL Curve 400 Incl. Mastbag",
            sku: "UF095920400",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/01_UF_Mast_Elite_FL_RDM_TF_605_3c012909-957d-4416-9255-3a9638db2bbf.png?v=1738343835",
            specs: {
              length: 400,
              diameter: "RDM",
              curve: "Constant FL Curve",
              carbon: "C100",
              carbonQuality: "T700 & T800",
              imcs: 19,
              baseFlex: 62,
              topFlex: 77,
              finishing: "Matte Black Spiral Taped",
              ferrule: "Universal Ferrule System",
              maxInsertion: "Maximum 60",
              weight: 1.55,
            },
          },
          mastOnly: {
            handle: "elite-rdm-c100-constant-fl-curve-400",
            name: "Elite RDM C100 Constant FL Curve 400",
            sku: "UF005920400",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/01_UF_Mast_Elite_FL_RDM_TF_605_3c012909-957d-4416-9255-3a9638db2bbf.png?v=1738343835",
          },
          withBag: {
            handle: "elite-rdm-c100-constant-fl-curve-400-incl-mastbag",
            name: "Elite RDM C100 Constant FL Curve 400 Incl. Mastbag",
            sku: "UF095920400",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/01_UF_Mast_Elite_FL_RDM_TF_605_3c012909-957d-4416-9255-3a9638db2bbf.png?v=1738343835",
          },
        },
      },
      430: {
        essentials: {
          base: {
            handle: "essentials-rdm-c50-constant-fl-curve-430-incl-mastbag",
            name: "Essentials RDM C50 Constant FL Curve 430 Incl. Mastbag",
            sku: "UF095520430",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_Essential_FL_RDM_TF_610_11c9930f-dea5-4823-961f-d38eb77aa205.png?v=1738391735",
            specs: {
              length: 430,
              diameter: "RDM",
              curve: "Constant FL Curve",
              carbon: "C50",
              carbonQuality: "T700",
              imcs: 21,
              baseFlex: 62,
              topFlex: 77,
              finishing: "Matte Black Spiral Taped",
              ferrule: "Universal Ferrule System",
              maxInsertion: "Maximum 60",
              weight: 2.43,
            },
          },
          mastOnly: {
            handle: "essentials-rdm-c50-constant-fl-curve-430",
            name: "Essentials RDM C50 Constant FL Curve 430",
            sku: "UF005520430",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_Essential_FL_RDM_TF_610_11c9930f-dea5-4823-961f-d38eb77aa205.png?v=1738391735",
          },
          withBag: {
            handle: "essentials-rdm-c50-constant-fl-curve-430-incl-mastbag",
            name: "Essentials RDM C50 Constant FL Curve 430 Incl. Mastbag",
            sku: "UF095520430",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_Essential_FL_RDM_TF_610_11c9930f-dea5-4823-961f-d38eb77aa205.png?v=1738391735",
          },
        },
        hd: {
          base: {
            handle: "hd-rdm-c75-constant-fl-curve-430-incl-mastbag",
            name: "HD RDM C75 Constant FL Curve 430 Incl. Mastbag",
            sku: "UF095720430",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_HD_FL_RDM_TF_598_6585d2c3-ed8b-4fb4-81e9-7ddf559fb5a9.png?v=1738345328",
            specs: {
              length: 430,
              diameter: "RDM",
              curve: "Constant FL Curve",
              carbon: "C75",
              carbonQuality: "T700",
              imcs: 21,
              baseFlex: 62,
              topFlex: 77,
              finishing: "Matte Black Spiral Taped",
              ferrule: "Universal Ferrule System",
              maxInsertion: "Maximum 60",
              weight: 1.89,
            },
          },
          mastOnly: {
            handle: "hd-rdm-c75-constant-fl-curve-430",
            name: "HD RDM C75 Constant FL Curve 430",
            sku: "UF005720430",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_HD_FL_RDM_TF_598_6585d2c3-ed8b-4fb4-81e9-7ddf559fb5a9.png?v=1738345328",
          },
          withBag: {
            handle: "hd-rdm-c75-constant-fl-curve-430-incl-mastbag",
            name: "HD RDM C75 Constant FL Curve 430 Incl. Mastbag",
            sku: "UF095720430",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_HD_FL_RDM_TF_598_6585d2c3-ed8b-4fb4-81e9-7ddf559fb5a9.png?v=1738345328",
          },
        },
        elite: {
          base: {
            handle: "elite-rdm-c100-constant-fl-curve-430-incl-mastbag",
            name: "Elite RDM C100 Constant FL Curve 430 Incl. Mastbag",
            sku: "UF095920430",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/01_UF_Mast_Elite_FL_RDM_TF_605_3c012909-957d-4416-9255-3a9638db2bbf.png?v=1738343835",
            specs: {
              length: 430,
              diameter: "RDM",
              curve: "Constant FL Curve",
              carbon: "C100",
              carbonQuality: "T700 & T800",
              imcs: 21,
              baseFlex: 62,
              topFlex: 77,
              finishing: "Matte Black Spiral Taped",
              ferrule: "Universal Ferrule System",
              maxInsertion: "Maximum 60",
              weight: 1.75,
            },
          },
          mastOnly: {
            handle: "elite-rdm-c100-constant-fl-curve-430",
            name: "Elite RDM C100 Constant FL Curve 430",
            sku: "UF005920430",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/01_UF_Mast_Elite_FL_RDM_TF_605_3c012909-957d-4416-9255-3a9638db2bbf.png?v=1738343835",
          },
          withBag: {
            handle: "elite-rdm-c100-constant-fl-curve-430-incl-mastbag",
            name: "Elite RDM C100 Constant FL Curve 430 Incl. Mastbag",
            sku: "UF095920430",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/01_UF_Mast_Elite_FL_RDM_TF_605_3c012909-957d-4416-9255-3a9638db2bbf.png?v=1738343835",
          },
        },
      },
      460: {
        essentials: {
          base: {
            handle: "essentials-rdm-c50-constant-fl-curve-460-incl-mastbag",
            name: "Essentials RDM C50 Constant FL Curve 460 Incl. Mastbag",
            sku: "UF095520460",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_Essential_FL_RDM_TF_610_11c9930f-dea5-4823-961f-d38eb77aa205.png?v=1738391735",
            specs: {
              length: 460,
              diameter: "RDM",
              curve: "Constant FL Curve",
              carbon: "C50",
              carbonQuality: "T700",
              imcs: 25,
              baseFlex: 62,
              topFlex: 77,
              finishing: "Matte Black Spiral Taped",
              ferrule: "Universal Ferrule System",
              maxInsertion: "Maximum 60",
              weight: 2.75,
            },
          },
          mastOnly: {
            handle: "essentials-rdm-c50-constant-fl-curve-460",
            name: "Essentials RDM C50 Constant FL Curve 460",
            sku: "UF005520460",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_Essential_FL_RDM_TF_610_11c9930f-dea5-4823-961f-d38eb77aa205.png?v=1738391735",
          },
          withBag: {
            handle: "essentials-rdm-c50-constant-fl-curve-460-incl-mastbag",
            name: "Essentials RDM C50 Constant FL Curve 460 Incl. Mastbag",
            sku: "UF095520460",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_Essential_FL_RDM_TF_610_11c9930f-dea5-4823-961f-d38eb77aa205.png?v=1738391735",
          },
        },
        hd: {
          base: {
            handle: "hd-rdm-c75-constant-fl-curve-460-incl-mastbag",
            name: "HD RDM C75 Constant FL Curve 460 Incl. Mastbag",
            sku: "UF095720460",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_HD_FL_RDM_TF_598_6585d2c3-ed8b-4fb4-81e9-7ddf559fb5a9.png?v=1738345328",
            specs: {
              length: 460,
              diameter: "RDM",
              curve: "Constant FL Curve",
              carbon: "C75",
              carbonQuality: "T700",
              imcs: 25,
              baseFlex: 62,
              topFlex: 77,
              finishing: "Matte Black Spiral Taped",
              ferrule: "Universal Ferrule System",
              maxInsertion: "Maximum 60",
              weight: 2.18,
            },
          },
          mastOnly: {
            handle: "hd-rdm-c75-constant-fl-curve-460",
            name: "HD RDM C75 Constant FL Curve 460",
            sku: "UF005720460",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_HD_FL_RDM_TF_598_6585d2c3-ed8b-4fb4-81e9-7ddf559fb5a9.png?v=1738345328",
          },
          withBag: {
            handle: "hd-rdm-c75-constant-fl-curve-460-incl-mastbag",
            name: "HD RDM C75 Constant FL Curve 460 Incl. Mastbag",
            sku: "UF095720460",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_HD_FL_RDM_TF_598_6585d2c3-ed8b-4fb4-81e9-7ddf559fb5a9.png?v=1738345328",
          },
        },
        elite: {
          base: {
            handle: "elite-rdm-c100-constant-fl-curve-460-incl-mastbag",
            name: "Elite RDM C100 Constant FL Curve 460 Incl. Mastbag",
            sku: "UF095920460",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/01_UF_Mast_Elite_FL_RDM_TF_605_3c012909-957d-4416-9255-3a9638db2bbf.png?v=1738343835",
            specs: {
              length: 460,
              diameter: "RDM",
              curve: "Constant FL Curve",
              carbon: "C100",
              carbonQuality: "T700 & T800",
              imcs: 25,
              baseFlex: 62,
              topFlex: 77,
              finishing: "Matte Black Spiral Taped",
              ferrule: "Universal Ferrule System",
              maxInsertion: "Maximum 60",
              weight: 1.94,
            },
          },
          mastOnly: {
            handle: "elite-rdm-c100-constant-fl-curve-460",
            name: "Elite RDM C100 Constant FL Curve 460",
            sku: "UF005920460",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/01_UF_Mast_Elite_FL_RDM_TF_605_3c012909-957d-4416-9255-3a9638db2bbf.png?v=1738343835",
          },
          withBag: {
            handle: "elite-rdm-c100-constant-fl-curve-460-incl-mastbag",
            name: "Elite RDM C100 Constant FL Curve 460 Incl. Mastbag",
            sku: "UF095920460",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/01_UF_Mast_Elite_FL_RDM_TF_605_3c012909-957d-4416-9255-3a9638db2bbf.png?v=1738343835",
          },
        },
      },
    },
    SDM: {
      400: {
        essentials: {
          base: {
            handle: "essentials-sdm-c50-constant-fl-curve-400-incl-mastbag",
            name: "Essentials SDM C50 Constant FL Curve 400 Incl. Mastbag",
            sku: "UF096020400",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_Essential_FL_SDM_TF_615_c48e9c82-f285-4641-a651-0b79c658c9a3.png?v=1738392051",
            specs: {
              length: 400,
              diameter: "SDM",
              curve: "Constant FL Curve",
              carbon: "C50",
              carbonQuality: "T700",
              imcs: 19,
              baseFlex: 62,
              topFlex: 77,
              finishing: "Matte Black Spiral Taped",
              ferrule: "Universal Ferrule System",
              maxInsertion: "Maximum 45",
              weight: 2.18,
            },
          },
          mastOnly: {
            handle: "essentials-sdm-c50-constant-fl-curve-400",
            name: "Essentials SDM C50 Constant FL Curve 400",
            sku: "UF006020400",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_Essential_FL_SDM_TF_615_c48e9c82-f285-4641-a651-0b79c658c9a3.png?v=1738392051",
          },
          withBag: {
            handle: "essentials-sdm-c50-constant-fl-curve-400-incl-mastbag",
            name: "Essentials SDM C50 Constant FL Curve 400 Incl. Mastbag",
            sku: "UF096020400",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_Essential_FL_SDM_TF_615_c48e9c82-f285-4641-a651-0b79c658c9a3.png?v=1738392051",
          },
        },
        hd: {
          base: {
            handle: "hd-sdm-c75-constant-fl-curve-400-incl-mastbag",
            name: "HD SDM C75 Constant FL Curve 400 Incl. Mastbag",
            sku: "UF096310400",
            image: "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_HD_FL_SDM_TF_623.png?v=1738390501",
            specs: {
              length: 400,
              diameter: "SDM",
              curve: "Constant FL Curve",
              carbon: "C75",
              carbonQuality: "T700",
              imcs: 19,
              baseFlex: 62,
              topFlex: 77,
              finishing: "Matte Black Spiral Taped",
              ferrule: "Universal Ferrule System",
              maxInsertion: "Maximum 45",
              weight: 1.65,
            },
          },
          mastOnly: {
            handle: "hd-sdm-c75-constant-fl-curve-400",
            name: "HD SDM C75 Constant FL Curve 400",
            sku: "UF006310400",
            image: "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_HD_FL_SDM_TF_623.png?v=1738390501",
          },
          withBag: {
            handle: "hd-sdm-c75-constant-fl-curve-400-incl-mastbag",
            name: "HD SDM C75 Constant FL Curve 400 Incl. Mastbag",
            sku: "UF096310400",
            image: "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_HD_FL_SDM_TF_623.png?v=1738390501",
          },
        },
        elite: {
          base: {
            handle: "elite-sdm-c100-constant-fl-curve-400-incl-mastbag",
            name: "Elite SDM C100 Constant FL Curve 400 Incl. Mastbag",
            sku: "UF096420400",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_Elite_FL_SDM_TF_633_aea3bb58-7272-4d30-bef2-79289f2199d2.png?v=1738344292",
            specs: {
              length: 400,
              diameter: "SDM",
              curve: "Constant FL Curve",
              carbon: "C100",
              carbonQuality: "T700 & T800",
              imcs: 19,
              baseFlex: 62,
              topFlex: 77,
              finishing: "Matte Black Spiral Taped",
              ferrule: "Universal Ferrule System",
              maxInsertion: "Maximum 45",
              weight: 1.46,
            },
          },
          mastOnly: {
            handle: "elite-sdm-c100-constant-fl-curve-400",
            name: "Elite SDM C100 Constant FL Curve 400",
            sku: "UF006420400",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_Elite_FL_SDM_TF_633_aea3bb58-7272-4d30-bef2-79289f2199d2.png?v=1738344292",
          },
          withBag: {
            handle: "elite-sdm-c100-constant-fl-curve-400-incl-mastbag",
            name: "Elite SDM C100 Constant FL Curve 400 Incl. Mastbag",
            sku: "UF096420400",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_Elite_FL_SDM_TF_633_aea3bb58-7272-4d30-bef2-79289f2199d2.png?v=1738344292",
          },
        },
      },
      430: {
        essentials: {
          base: {
            handle: "essentials-sdm-c50-constant-fl-curve-430-incl-mastbag",
            name: "Essentials SDM C50 Constant FL Curve 430 Incl. Mastbag",
            sku: "UF096020430",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_Essential_FL_SDM_TF_615_c48e9c82-f285-4641-a651-0b79c658c9a3.png?v=1738392051",
            specs: {
              length: 430,
              diameter: "SDM",
              curve: "Constant FL Curve",
              carbon: "C50",
              carbonQuality: "T700",
              imcs: 21,
              baseFlex: 62,
              topFlex: 77,
              finishing: "Matte Black Spiral Taped",
              ferrule: "Universal Ferrule System",
              maxInsertion: "Maximum 45",
              weight: 2.33,
            },
          },
          mastOnly: {
            handle: "essentials-sdm-c50-constant-fl-curve-430",
            name: "Essentials SDM C50 Constant FL Curve 430",
            sku: "UF006020430",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_Essential_FL_SDM_TF_615_c48e9c82-f285-4641-a651-0b79c658c9a3.png?v=1738392051",
          },
          withBag: {
            handle: "essentials-sdm-c50-constant-fl-curve-430-incl-mastbag",
            name: "Essentials SDM C50 Constant FL Curve 430 Incl. Mastbag",
            sku: "UF096020430",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_Essential_FL_SDM_TF_615_c48e9c82-f285-4641-a651-0b79c658c9a3.png?v=1738392051",
          },
        },
        hd: {
          base: {
            handle: "hd-sdm-c75-constant-fl-curve-430-incl-mastbag",
            name: "HD SDM C75 Constant FL Curve 430 Incl. Mastbag",
            sku: "UF096320430",
            image: "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_HD_FL_SDM_TF_623.png?v=1738390501",
            specs: {
              length: 430,
              diameter: "SDM",
              curve: "Constant FL Curve",
              carbon: "C75",
              carbonQuality: "T700",
              imcs: 21,
              baseFlex: 62,
              topFlex: 77,
              finishing: "Matte Black Spiral Taped",
              ferrule: "Universal Ferrule System",
              maxInsertion: "Maximum 45",
              weight: 1.84,
            },
          },
          mastOnly: {
            handle: "hd-sdm-c75-constant-fl-curve-430",
            name: "HD SDM C75 Constant FL Curve 430",
            sku: "UF006320430",
            image: "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_HD_FL_SDM_TF_623.png?v=1738390501",
          },
          withBag: {
            handle: "hd-sdm-c75-constant-fl-curve-430-incl-mastbag",
            name: "HD SDM C75 Constant FL Curve 430 Incl. Mastbag",
            sku: "UF096320430",
            image: "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_HD_FL_SDM_TF_623.png?v=1738390501",
          },
        },
        elite: {
          base: {
            handle: "elite-sdm-c100-constant-fl-curve-430-incl-mastbag",
            name: "Elite SDM C100 Constant FL Curve 430 Incl. Mastbag",
            sku: "UF096420430",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_Elite_FL_SDM_TF_633_aea3bb58-7272-4d30-bef2-79289f2199d2.png?v=1738344292",
            specs: {
              length: 430,
              diameter: "SDM",
              curve: "Constant FL Curve",
              carbon: "C100",
              carbonQuality: "T700 & T800",
              imcs: 21,
              baseFlex: 62,
              topFlex: 77,
              finishing: "Matte Black Spiral Taped",
              ferrule: "Universal Ferrule System",
              maxInsertion: "Maximum 45",
              weight: 1.65,
            },
          },
          mastOnly: {
            handle: "elite-sdm-c100-constant-fl-curve-430",
            name: "Elite SDM C100 Constant FL Curve 430",
            sku: "UF006420430",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_Elite_FL_SDM_TF_633_aea3bb58-7272-4d30-bef2-79289f2199d2.png?v=1738344292",
          },
          withBag: {
            handle: "elite-sdm-c100-constant-fl-curve-430-incl-mastbag",
            name: "Elite SDM C100 Constant FL Curve 430 Incl. Mastbag",
            sku: "UF096420430",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_Elite_FL_SDM_TF_633_aea3bb58-7272-4d30-bef2-79289f2199d2.png?v=1738344292",
          },
        },
      },
      460: {
        essentials: {
          base: {
            handle: "essentials-sdm-c50-constant-fl-curve-460-incl-mastbag",
            name: "Essentials SDM C50 Constant FL Curve 460 Incl. Mastbag",
            sku: "UF096020460",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_Essential_FL_SDM_TF_615_c48e9c82-f285-4641-a651-0b79c658c9a3.png?v=1738392051",
            specs: {
              length: 460,
              diameter: "SDM",
              curve: "Constant FL Curve",
              carbon: "C50",
              carbonQuality: "T700",
              imcs: 25,
              baseFlex: 62,
              topFlex: 77,
              finishing: "Matte Black Spiral Taped",
              ferrule: "Universal Ferrule System",
              maxInsertion: "Maximum 45",
              weight: 2.62,
            },
          },
          mastOnly: {
            handle: "essentials-sdm-c50-constant-fl-curve-460",
            name: "Essentials SDM C50 Constant FL Curve 460",
            sku: "UF006020460",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_Essential_FL_SDM_TF_615_c48e9c82-f285-4641-a651-0b79c658c9a3.png?v=1738392051",
          },
          withBag: {
            handle: "essentials-sdm-c50-constant-fl-curve-460-incl-mastbag",
            name: "Essentials SDM C50 Constant FL Curve 460 Incl. Mastbag",
            sku: "UF096020460",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_Essential_FL_SDM_TF_615_c48e9c82-f285-4641-a651-0b79c658c9a3.png?v=1738392051",
          },
        },
        hd: {
          base: {
            handle: "hd-sdm-c75-constant-fl-curve-460-incl-mastbag",
            name: "HD SDM C75 Constant FL Curve 460 Incl. Mastbag",
            sku: "UF096320460",
            image: "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_HD_FL_SDM_TF_623.png?v=1738390501",
            specs: {
              length: 460,
              diameter: "SDM",
              curve: "Constant FL Curve",
              carbon: "C75",
              carbonQuality: "T700",
              imcs: 25,
              baseFlex: 62,
              topFlex: 77,
              finishing: "Matte Black Spiral Taped",
              ferrule: "Universal Ferrule System",
              maxInsertion: "Maximum 45",
              weight: 2.14,
            },
          },
          mastOnly: {
            handle: "hd-sdm-c75-constant-fl-curve-460",
            name: "HD SDM C75 Constant FL Curve 460",
            sku: "UF006320460",
            image: "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_HD_FL_SDM_TF_623.png?v=1738390501",
          },
          withBag: {
            handle: "hd-sdm-c75-constant-fl-curve-460-incl-mastbag",
            name: "HD SDM C75 Constant FL Curve 460 Incl. Mastbag",
            sku: "UF096320460",
            image: "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_HD_FL_SDM_TF_623.png?v=1738390501",
          },
        },
        elite: {
          base: {
            handle: "elite-sdm-c100-constant-fl-curve-460-incl-mastbag",
            name: "Elite SDM C100 Constant FL Curve 460 Incl. Mastbag",
            sku: "UF096420460",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_Elite_FL_SDM_TF_633_aea3bb58-7272-4d30-bef2-79289f2199d2.png?v=1738344292",
            specs: {
              length: 460,
              diameter: "SDM",
              curve: "Constant FL Curve",
              carbon: "C100",
              carbonQuality: "T700 & T800",
              imcs: 25,
              baseFlex: 62,
              topFlex: 77,
              finishing: "Matte Black Spiral Taped",
              ferrule: "Universal Ferrule System",
              maxInsertion: "Maximum 45",
              weight: 1.89,
            },
          },
          mastOnly: {
            handle: "elite-sdm-c100-constant-fl-curve-460",
            name: "Elite SDM C100 Constant FL Curve 460",
            sku: "UF006420460",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_Elite_FL_SDM_TF_633_aea3bb58-7272-4d30-bef2-79289f2199d2.png?v=1738344292",
          },
          withBag: {
            handle: "elite-sdm-c100-constant-fl-curve-460-incl-mastbag",
            name: "Elite SDM C100 Constant FL Curve 460 Incl. Mastbag",
            sku: "UF096420460",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_Elite_FL_SDM_TF_633_aea3bb58-7272-4d30-bef2-79289f2199d2.png?v=1738344292",
          },
        },
      },
      490: {
        essentials: {
          base: {
            handle: "essentials-sdm-c50-constant-fl-curve-490-incl-mastbag",
            name: "Essentials SDM C50 Constant FL Curve 490 Incl. Mastbag",
            sku: "UF096020490",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_Essential_FL_SDM_TF_615_c48e9c82-f285-4641-a651-0b79c658c9a3.png?v=1738392051",
            specs: {
              length: 490,
              diameter: "SDM",
              curve: "Constant FL Curve",
              carbon: "C50",
              carbonQuality: "T700",
              imcs: 29,
              baseFlex: 62,
              topFlex: 77,
              finishing: "Matte Black Spiral Taped",
              ferrule: "Universal Ferrule System",
              maxInsertion: "Maximum 45",
              weight: 2.91,
            },
          },
          mastOnly: {
            handle: "essentials-sdm-c50-constant-fl-curve-490",
            name: "Essentials SDM C50 Constant FL Curve 490",
            sku: "UF006020490",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_Essential_FL_SDM_TF_615_c48e9c82-f285-4641-a651-0b79c658c9a3.png?v=1738392051",
          },
          withBag: {
            handle: "essentials-sdm-c50-constant-fl-curve-490-incl-mastbag",
            name: "Essentials SDM C50 Constant FL Curve 490 Incl. Mastbag",
            sku: "UF096020490",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_Essential_FL_SDM_TF_615_c48e9c82-f285-4641-a651-0b79c658c9a3.png?v=1738392051",
          },
        },
        hd: {
          base: {
            handle: "hd-sdm-c75-constant-fl-curve-490-incl-mastbag",
            name: "HD SDM C75 Constant FL Curve 490 Incl. Mastbag",
            sku: "UF096320490",
            image: "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_HD_FL_SDM_TF_623.png?v=1738390501",
            specs: {
              length: 490,
              diameter: "SDM",
              curve: "Constant FL Curve",
              carbon: "C75",
              carbonQuality: "T700",
              imcs: 29,
              baseFlex: 62,
              topFlex: 77,
              finishing: "Matte Black Spiral Taped",
              ferrule: "Universal Ferrule System",
              maxInsertion: "Maximum 60",
              weight: 2.43,
            },
          },
          mastOnly: {
            handle: "hd-sdm-c75-constant-fl-curve-490",
            name: "HD SDM C75 Constant FL Curve 490",
            sku: "UF006320490",
            image: "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_HD_FL_SDM_TF_623.png?v=1738390501",
          },
          withBag: {
            handle: "hd-sdm-c75-constant-fl-curve-490-incl-mastbag",
            name: "HD SDM C75 Constant FL Curve 490 Incl. Mastbag",
            sku: "UF096320490",
            image: "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_HD_FL_SDM_TF_623.png?v=1738390501",
          },
        },
        elite: {
          base: {
            handle: "elite-sdm-c100-constant-fl-curve-490-incl-mastbag",
            name: "Elite SDM C100 Constant FL Curve 490 Incl. Mastbag",
            sku: "UF096420490",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_Elite_FL_SDM_TF_633_aea3bb58-7272-4d30-bef2-79289f2199d2.png?v=1738344292",
            specs: {
              length: 490,
              diameter: "SDM",
              curve: "Constant FL Curve",
              carbon: "C100",
              carbonQuality: "T700 & T800",
              imcs: 29,
              baseFlex: 62,
              topFlex: 77,
              finishing: "Matte Black Spiral Taped",
              ferrule: "Universal Ferrule System",
              maxInsertion: "Maximum 60",
              weight: 2.14,
            },
          },
          mastOnly: {
            handle: "elite-sdm-c100-constant-fl-curve-490",
            name: "Elite SDM C100 Constant FL Curve 490",
            sku: "UF006420490",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_Elite_FL_SDM_TF_633_aea3bb58-7272-4d30-bef2-79289f2199d2.png?v=1738344292",
          },
          withBag: {
            handle: "elite-sdm-c100-constant-fl-curve-490-incl-mastbag",
            name: "Elite SDM C100 Constant FL Curve 490 Incl. Mastbag",
            sku: "UF096420490",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_Elite_FL_SDM_TF_633_aea3bb58-7272-4d30-bef2-79289f2199d2.png?v=1738344292",
          },
        },
      },
    },
  },
  fh: {
    RDM: {
      340: {
        essentials: {
          base: {
            handle: "essentials-rdm-c50-constant-fh-curve-340-incl-mastbag",
            name: "Essentials RDM C50 Constant FH Curve 340 Incl. Mastbag",
            sku: "UF095530340",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_Essential_FH_RDM_TF_608_df803714-a580-43b8-92ce-0d539bb24752.png?v=1738391443",
            specs: {
              length: 340,
              diameter: "RDM",
              curve: "Constant FH Curve",
              carbon: "C50",
              carbonQuality: "T700",
              imcs: 14,
              baseFlex: 64,
              topFlex: 79,
              finishing: "Matte Black Spiral Taped",
              ferrule: "Universal Ferrule System",
              maxInsertion: "Maximum 60",
              weight: 1.75,
            },
          },
          mastOnly: {
            handle: "essentials-rdm-c50-constant-fh-curve-340",
            name: "Essentials RDM C50 Constant FH Curve 340",
            sku: "UF005530340",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_Essential_FH_RDM_TF_608_df803714-a580-43b8-92ce-0d539bb24752.png?v=1738391443",
          },
          withBag: {
            handle: "essentials-rdm-c50-constant-fh-curve-340-incl-mastbag",
            name: "Essentials RDM C50 Constant FH Curve 340 Incl. Mastbag",
            sku: "UF095530340",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_Essential_FH_RDM_TF_608_df803714-a580-43b8-92ce-0d539bb24752.png?v=1738391443",
          },
        },
        hd: {
          base: {
            handle: "hd-rdm-c75-constant-fh-curve-340-incl-mastbag",
            name: "HD RDM C75 Constant FH Curve 340 Incl. Mastbag",
            sku: "UF095730340",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_HD_FH_RDM_TF_601_349ca79c-a4a7-4420-8fcd-1c254bc1739a.png?v=1738345228",
            specs: {
              length: 340,
              diameter: "RDM",
              curve: "Constant FH Curve",
              carbon: "C75",
              carbonQuality: "T700",
              imcs: 14,
              baseFlex: 64,
              topFlex: 79,
              finishing: "Matte Black Spiral Taped",
              ferrule: "Universal Ferrule System",
              maxInsertion: "Maximum 60",
              weight: 1.36,
            },
          },
          mastOnly: {
            handle: "hd-rdm-c75-constant-fh-curve-340",
            name: "HD RDM C75 Constant FH Curve 340",
            sku: "UF005730340",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_HD_FH_RDM_TF_601_54ae4895-d2e0-4da8-b2b7-351a62036a1a.png?v=1738345231",
          },
          withBag: {
            handle: "hd-rdm-c75-constant-fh-curve-340-incl-mastbag",
            name: "HD RDM C75 Constant FH Curve 340 Incl. Mastbag",
            sku: "UF095730340",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_HD_FH_RDM_TF_601_349ca79c-a4a7-4420-8fcd-1c254bc1739a.png?v=1738345228",
          },
        },
        elite: {
          base: {
            handle: "elite-rdm-c100-constant-fh-curve-340-incl-mastbag",
            name: "Elite RDM C100 Constant FH Curve 340 Incl. Mastbag",
            sku: "UF095930340",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/01-UF_Mast_Elite_FH_RDM_TF_604.png?v=1738343712",
            specs: {
              length: 340,
              diameter: "RDM",
              curve: "Constant FH Curve",
              carbon: "C100",
              carbonQuality: "T700 & T800",
              imcs: 14,
              baseFlex: 64,
              topFlex: 79,
              finishing: "Matte Black Spiral Taped",
              ferrule: "Universal Ferrule System",
              maxInsertion: "Maximum 60",
              weight: 1.21,
            },
          },
          mastOnly: {
            handle: "elite-rdm-c100-constant-fh-curve-340",
            name: "Elite RDM C100 Constant FH Curve 340",
            sku: "UF005930340",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/01-UF_Mast_Elite_FH_RDM_TF_604.png?v=1738343712",
          },
          withBag: {
            handle: "elite-rdm-c100-constant-fh-curve-340-incl-mastbag",
            name: "Elite RDM C100 Constant FH Curve 340 Incl. Mastbag",
            sku: "UF095930340",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/01-UF_Mast_Elite_FH_RDM_TF_604.png?v=1738343712",
          },
        },
      },
      370: {
        essentials: {
          base: {
            handle: "essentials-rdm-c50-constant-fh-curve-370-incl-mastbag",
            name: "Essentials RDM C50 Constant FH Curve 370 Incl. Mastbag",
            sku: "UF095530370",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_Essential_FH_RDM_TF_608_df803714-a580-43b8-92ce-0d539bb24752.png?v=1738391443",
            specs: {
              length: 370,
              diameter: "RDM",
              curve: "Constant FH Curve",
              carbon: "C50",
              carbonQuality: "T700",
              imcs: 17,
              baseFlex: 64,
              topFlex: 79,
              finishing: "Matte Black Spiral Taped",
              ferrule: "Universal Ferrule System",
              maxInsertion: "Maximum 60",
              weight: 2.04,
            },
          },
          mastOnly: {
            handle: "essentials-rdm-c50-constant-fh-curve-370",
            name: "Essentials RDM C50 Constant FH Curve 370",
            sku: "UF005530370",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_Essential_FH_RDM_TF_608_df803714-a580-43b8-92ce-0d539bb24752.png?v=1738391443",
          },
          withBag: {
            handle: "essentials-rdm-c50-constant-fh-curve-370-incl-mastbag",
            name: "Essentials RDM C50 Constant FH Curve 370 Incl. Mastbag",
            sku: "UF095530370",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_Essential_FH_RDM_TF_608_df803714-a580-43b8-92ce-0d539bb24752.png?v=1738391443",
          },
        },
        hd: {
          base: {
            handle: "hd-rdm-c75-constant-fh-curve-370-incl-mastbag",
            name: "HD RDM C75 Constant FH Curve 370 Incl. Mastbag",
            sku: "UF095730370",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_HD_FH_RDM_TF_601_349ca79c-a4a7-4420-8fcd-1c254bc1739a.png?v=1738345228",
            specs: {
              length: 370,
              diameter: "RDM",
              curve: "Constant FH Curve",
              carbon: "C75",
              carbonQuality: "T700",
              imcs: 17,
              baseFlex: 64,
              topFlex: 79,
              finishing: "Matte Black Spiral Taped",
              ferrule: "Universal Ferrule System",
              maxInsertion: "Maximum 60",
              weight: 1.5,
            },
          },
          mastOnly: {
            handle: "hd-rdm-c75-constant-fh-curve-370",
            name: "HD RDM C75 Constant FH Curve 370",
            sku: "UF005730370",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_HD_FH_RDM_TF_601_349ca79c-a4a7-4420-8fcd-1c254bc1739a.png?v=1738345228",
          },
          withBag: {
            handle: "hd-rdm-c75-constant-fh-curve-370-incl-mastbag",
            name: "HD RDM C75 Constant FH Curve 370 Incl. Mastbag",
            sku: "UF095730370",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_HD_FH_RDM_TF_601_349ca79c-a4a7-4420-8fcd-1c254bc1739a.png?v=1738345228",
          },
        },
        elite: {
          base: {
            handle: "elite-rdm-c100-constant-fh-curve-370-incl-mastbag",
            name: "Elite RDM C100 Constant FH Curve 370 Incl. Mastbag",
            sku: "UF095930370",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/01-UF_Mast_Elite_FH_RDM_TF_604.png?v=1738343712",
            specs: {
              length: 370,
              diameter: "RDM",
              curve: "Constant FH Curve",
              carbon: "C100",
              carbonQuality: "T700 & T800",
              imcs: 17,
              baseFlex: 64,
              topFlex: 79,
              finishing: "Matte Black Spiral Taped",
              ferrule: "Universal Ferrule System",
              maxInsertion: "Maximum 60",
              weight: 1.36,
            },
          },
          mastOnly: {
            handle: "elite-rdm-c100-constant-fh-curve-370",
            name: "Elite RDM C100 Constant FH Curve 370",
            sku: "UF005930370",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/01-UF_Mast_Elite_FH_RDM_TF_604.png?v=1738343712",
          },
          withBag: {
            handle: "elite-rdm-c100-constant-fh-curve-370-incl-mastbag",
            name: "Elite RDM C100 Constant FH Curve 370 Incl. Mastbag",
            sku: "UF095930370",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/01-UF_Mast_Elite_FH_RDM_TF_604.png?v=1738343712",
          },
        },
      },
      400: {
        essentials: {
          base: {
            handle: "essentials-rdm-c50-constant-fh-curve-400-incl-mastbag",
            name: "Essentials RDM C50 Constant FH Curve 400 Incl. Mastbag",
            sku: "UF095530400",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_Essential_FH_RDM_TF_608_df803714-a580-43b8-92ce-0d539bb24752.png?v=1738391443",
            specs: {
              length: 400,
              diameter: "RDM",
              curve: "Constant FH Curve",
              carbon: "C50",
              carbonQuality: "T700",
              imcs: 19,
              baseFlex: 64,
              topFlex: 79,
              finishing: "Matte Black Spiral Taped",
              ferrule: "Universal Ferrule System",
              maxInsertion: "Maximum 60",
              weight: 2.23,
            },
          },
          mastOnly: {
            handle: "essentials-rdm-c50-constant-fh-curve-400",
            name: "Essentials RDM C50 Constant FH Curve 400",
            sku: "UF005530400",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_Essential_FH_RDM_TF_608_df803714-a580-43b8-92ce-0d539bb24752.png?v=1738391443",
          },
          withBag: {
            handle: "essentials-rdm-c50-constant-fh-curve-400-incl-mastbag",
            name: "Essentials RDM C50 Constant FH Curve 400 Incl. Mastbag",
            sku: "UF095530400",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_Essential_FH_RDM_TF_608_df803714-a580-43b8-92ce-0d539bb24752.png?v=1738391443",
          },
        },
        hd: {
          base: {
            handle: "hd-rdm-c75-constant-fh-curve-400-incl-mastbag",
            name: "HD RDM C75 Constant FH Curve 400 Incl. Mastbag",
            sku: "UF095730400",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_HD_FH_RDM_TF_601_349ca79c-a4a7-4420-8fcd-1c254bc1739a.png?v=1738345228",
            specs: {
              length: 400,
              diameter: "RDM",
              curve: "Constant FH Curve",
              carbon: "C75",
              carbonQuality: "T700",
              imcs: 19,
              baseFlex: 64,
              topFlex: 79,
              finishing: "Matte Black Spiral Taped",
              ferrule: "Universal Ferrule System",
              maxInsertion: "Maximum 60",
              weight: 1.7,
            },
          },
          mastOnly: {
            handle: "hd-rdm-c75-constant-fh-curve-400",
            name: "HD RDM C75 Constant FH Curve 400",
            sku: "UF005730400",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_HD_FH_RDM_TF_601_349ca79c-a4a7-4420-8fcd-1c254bc1739a.png?v=1738345228",
          },
          withBag: {
            handle: "hd-rdm-c75-constant-fh-curve-400-incl-mastbag",
            name: "HD RDM C75 Constant FH Curve 400 Incl. Mastbag",
            sku: "UF095730400",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_HD_FH_RDM_TF_601_349ca79c-a4a7-4420-8fcd-1c254bc1739a.png?v=1738345228",
          },
        },
        elite: {
          base: {
            handle: "elite-rdm-c100-constant-fh-curve-400-incl-mastbag",
            name: "Elite RDM C100 Constant FH Curve 400 Incl. Mastbag",
            sku: "UF095930400",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/01-UF_Mast_Elite_FH_RDM_TF_604_df320874-e3eb-45c8-b9c8-170831042d9a.png?v=1738343737",
            specs: {
              length: 400,
              diameter: "RDM",
              curve: "Constant FH Curve",
              carbon: "C100",
              carbonQuality: "T700 & T800",
              imcs: 19,
              baseFlex: 64,
              topFlex: 79,
              finishing: "Matte Black Spiral Taped",
              ferrule: "Universal Ferrule System",
              maxInsertion: "Maximum 60",
              weight: 1.55,
            },
          },
          mastOnly: {
            handle: "elite-rdm-c100-constant-fh-curve-400",
            name: "Elite RDM C100 Constant FH Curve 400",
            sku: "UF005930400",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/01-UF_Mast_Elite_FH_RDM_TF_604_11d29294-be5c-4560-abd2-65f3e55d33fb.png?v=1738343766",
          },
          withBag: {
            handle: "elite-rdm-c100-constant-fh-curve-400-incl-mastbag",
            name: "Elite RDM C100 Constant FH Curve 400 Incl. Mastbag",
            sku: "UF095930400",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/01-UF_Mast_Elite_FH_RDM_TF_604_df320874-e3eb-45c8-b9c8-170831042d9a.png?v=1738343737",
          },
        },
      },
      430: {
        essentials: {
          base: {
            handle: "essentials-rdm-c50-constant-fh-curve-430-incl-mastbag",
            name: "Essentials RDM C50 Constant FH Curve 430 Incl. Mastbag",
            sku: "UF095530430",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_Essential_FH_RDM_TF_608_df803714-a580-43b8-92ce-0d539bb24752.png?v=1738391443",
            specs: {
              length: 430,
              diameter: "RDM",
              curve: "Constant FH Curve",
              carbon: "C50",
              carbonQuality: "T700",
              imcs: 21,
              baseFlex: 64,
              topFlex: 79,
              finishing: "Matte Black Spiral Taped",
              ferrule: "Universal Ferrule System",
              maxInsertion: "Maximum 60",
              weight: 2.43,
            },
          },
          mastOnly: {
            handle: "essentials-rdm-c50-constant-fh-curve-430",
            name: "Essentials RDM C50 Constant FH Curve 430",
            sku: "UF005530430",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_Essential_FH_RDM_TF_608_df803714-a580-43b8-92ce-0d539bb24752.png?v=1738391443",
          },
          withBag: {
            handle: "essentials-rdm-c50-constant-fh-curve-430-incl-mastbag",
            name: "Essentials RDM C50 Constant FH Curve 430 Incl. Mastbag",
            sku: "UF095530430",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_Essential_FH_RDM_TF_608_df803714-a580-43b8-92ce-0d539bb24752.png?v=1738391443",
          },
        },
        hd: {
          base: {
            handle: "hd-rdm-c75-constant-fh-curve-430-incl-mastbag",
            name: "HD RDM C75 Constant FH Curve 430 Incl. Mastbag",
            sku: "UF095730430",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_HD_FH_RDM_TF_601_349ca79c-a4a7-4420-8fcd-1c254bc1739a.png?v=1738345228",
            specs: {
              length: 430,
              diameter: "RDM",
              curve: "Constant FH Curve",
              carbon: "C75",
              carbonQuality: "T700",
              imcs: 21,
              baseFlex: 64,
              topFlex: 79,
              finishing: "Matte Black Spiral Taped",
              ferrule: "Universal Ferrule System",
              maxInsertion: "Maximum 45",
              weight: 1.89,
            },
          },
          mastOnly: {
            handle: "hd-rdm-c75-constant-fh-curve-430",
            name: "HD RDM C75 Constant FH Curve 430",
            sku: "UF005730430",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_HD_FH_RDM_TF_601_349ca79c-a4a7-4420-8fcd-1c254bc1739a.png?v=1738345228",
          },
          withBag: {
            handle: "hd-rdm-c75-constant-fh-curve-430-incl-mastbag",
            name: "HD RDM C75 Constant FH Curve 430 Incl. Mastbag",
            sku: "UF095730430",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_HD_FH_RDM_TF_601_349ca79c-a4a7-4420-8fcd-1c254bc1739a.png?v=1738345228",
          },
        },
        elite: {
          base: {
            handle: "elite-rdm-c100-constant-fh-curve-430-incl-mastbag",
            name: "Elite RDM C100 Constant FH Curve 430 Incl. Mastbag",
            sku: "UF095930430",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/01-UF_Mast_Elite_FH_RDM_TF_604_11d29294-be5c-4560-abd2-65f3e55d33fb.png?v=1738343766",
            specs: {
              length: 430,
              diameter: "RDM",
              curve: "Constant FH Curve",
              carbon: "C100",
              carbonQuality: "T700 & T800",
              imcs: 21,
              baseFlex: 64,
              topFlex: 79,
              finishing: "Matte Black Spiral Taped",
              ferrule: "Universal Ferrule System",
              maxInsertion: "Maximum 60",
              weight: 1.75,
            },
          },
          mastOnly: {
            handle: "elite-rdm-c100-constant-fh-curve-430",
            name: "Elite RDM C100 Constant FH Curve 430",
            sku: "UF005930430",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/01-UF_Mast_Elite_FH_RDM_TF_604_0a8095dd-3726-4b4f-8a53-d7eef21592c7.png?v=1738343743",
          },
          withBag: {
            handle: "elite-rdm-c100-constant-fh-curve-430-incl-mastbag",
            name: "Elite RDM C100 Constant FH Curve 430 Incl. Mastbag",
            sku: "UF095930430",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/01-UF_Mast_Elite_FH_RDM_TF_604_11d29294-be5c-4560-abd2-65f3e55d33fb.png?v=1738343766",
          },
        },
      },
      460: {
        essentials: {
          base: {
            handle: "essentials-rdm-c50-constant-fh-curve-460-incl-mastbag",
            name: "Essentials RDM C50 Constant FH Curve 460 Incl. Mastbag",
            sku: "UF095530460",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_Essential_FH_RDM_TF_608_df803714-a580-43b8-92ce-0d539bb24752.png?v=1738391443",
            specs: {
              length: 460,
              diameter: "RDM",
              curve: "Constant FH Curve",
              carbon: "C50",
              carbonQuality: "T700",
              imcs: 25,
              baseFlex: 64,
              topFlex: 79,
              finishing: "Matte Black Spiral Taped",
              ferrule: "Universal Ferrule System",
              maxInsertion: "Maximum 60",
              weight: 2.75,
            },
          },
          mastOnly: {
            handle: "essentials-rdm-c50-constant-fh-curve-460",
            name: "Essentials RDM C50 Constant FH Curve 460",
            sku: "UF005530460",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_Essential_FH_RDM_TF_608_df803714-a580-43b8-92ce-0d539bb24752.png?v=1738391443",
          },
          withBag: {
            handle: "essentials-rdm-c50-constant-fh-curve-460-incl-mastbag",
            name: "Essentials RDM C50 Constant FH Curve 460 Incl. Mastbag",
            sku: "UF095530460",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_Essential_FH_RDM_TF_608_df803714-a580-43b8-92ce-0d539bb24752.png?v=1738391443",
          },
        },
        hd: {
          base: {
            handle: "hd-rdm-c75-constant-fh-curve-460-incl-mastbag",
            name: "HD RDM C75 Constant FH Curve 460 Incl. Mastbag",
            sku: "UF095730460",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_HD_FH_RDM_TF_601_349ca79c-a4a7-4420-8fcd-1c254bc1739a.png?v=1738345228",
            specs: {
              length: 460,
              diameter: "RDM",
              curve: "Constant FH Curve",
              carbon: "C75",
              carbonQuality: "T700",
              imcs: 25,
              baseFlex: 64,
              topFlex: 79,
              finishing: "Matte Black Spiral Taped",
              ferrule: "Universal Ferrule System",
              maxInsertion: "Maximum 60",
              weight: 2.18,
            },
          },
          mastOnly: {
            handle: "hd-rdm-c75-constant-fh-curve-460",
            name: "HD RDM C75 Constant FH Curve 460",
            sku: "UF005730460",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_HD_FH_RDM_TF_601_349ca79c-a4a7-4420-8fcd-1c254bc1739a.png?v=1738345228",
          },
          withBag: {
            handle: "hd-rdm-c75-constant-fh-curve-460-incl-mastbag",
            name: "HD RDM C75 Constant FH Curve 460 Incl. Mastbag",
            sku: "UF095730460",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_HD_FH_RDM_TF_601_349ca79c-a4a7-4420-8fcd-1c254bc1739a.png?v=1738345228",
          },
        },
        elite: {
          base: {
            handle: "elite-rdm-c100-constant-fh-curve-460-incl-mastbag",
            name: "Elite RDM C100 Constant FH Curve 460 Incl. Mastbag",
            sku: "UF095930460",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/01-UF_Mast_Elite_FH_RDM_TF_604_c8001ab2-0f00-41b4-b6b7-d8e619a360f0.png?v=1738343750",
            specs: {
              length: 460,
              diameter: "RDM",
              curve: "Constant FH Curve",
              carbon: "C100",
              carbonQuality: "T700 & T800",
              imcs: 25,
              baseFlex: 64,
              topFlex: 79,
              finishing: "Matte Black Spiral Taped",
              ferrule: "Universal Ferrule System",
              maxInsertion: "Maximum 60",
              weight: 1.94,
            },
          },
          mastOnly: {
            handle: "elite-rdm-c100-constant-fh-curve-460",
            name: "Elite RDM C100 Constant FH Curve 460",
            sku: "UF005930460",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/01-UF_Mast_Elite_FH_RDM_TF_604_04e0aa39-a7ea-4399-bd03-ae4eabc68e30.png?v=1738343755",
          },
          withBag: {
            handle: "elite-rdm-c100-constant-fh-curve-460-incl-mastbag",
            name: "Elite RDM C100 Constant FH Curve 460 Incl. Mastbag",
            sku: "UF095930460",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/01-UF_Mast_Elite_FH_RDM_TF_604_c8001ab2-0f00-41b4-b6b7-d8e619a360f0.png?v=1738343750",
          },
        },
      },
    },
    SDM: {
      400: {
        essentials: {
          base: {
            handle: "essentials-sdm-c50-constant-fh-curve-400-incl-mastbag",
            name: "Essentials SDM C50 Constant FH Curve 400 Incl. Mastbag",
            sku: "UF096030400",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_Essential_FH_SDM_TF_620_e5ba973e-7de2-4245-a641-46e0c8e4e136.png?v=1738391887",
            specs: {
              length: 400,
              diameter: "SDM",
              curve: "Constant FH Curve",
              carbon: "C50",
              carbonQuality: "T700",
              imcs: 19,
              baseFlex: 64,
              topFlex: 79,
              finishing: "Matte Black Spiral Taped",
              ferrule: "Universal Ferrule System",
              maxInsertion: "Maximum 45",
              weight: 2.18,
            },
          },
          mastOnly: {
            handle: "essentials-sdm-c50-constant-fh-curve-400",
            name: "Essentials SDM C50 Constant FH Curve 400",
            sku: "UF006030400",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_Essential_FH_SDM_TF_620_e5ba973e-7de2-4245-a641-46e0c8e4e136.png?v=1738391887",
          },
          withBag: {
            handle: "essentials-sdm-c50-constant-fh-curve-400-incl-mastbag",
            name: "Essentials SDM C50 Constant FH Curve 400 Incl. Mastbag",
            sku: "UF096030400",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_Essential_FH_SDM_TF_620_e5ba973e-7de2-4245-a641-46e0c8e4e136.png?v=1738391887",
          },
        },
        hd: {
          base: {
            handle: "hd-sdm-c75-constant-fh-curve-400-incl-mastbag",
            name: "HD SDM C75 Constant FH Curve 400 Incl. Mastbag",
            sku: "UF096330400",
            image: "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_HD_FH_SDM_TF_627.png?v=1738390379",
            specs: {
              length: 400,
              diameter: "SDM",
              curve: "Constant FH Curve",
              carbon: "C75",
              carbonQuality: "T700",
              imcs: 19,
              baseFlex: 64,
              topFlex: 79,
              finishing: "Matte Black Spiral Taped",
              ferrule: "Universal Ferrule System",
              maxInsertion: "Maximum 45",
              weight: 1.65,
            },
          },
          mastOnly: {
            handle: "hd-sdm-c75-constant-fh-curve-400",
            name: "HD SDM C75 Constant FH Curve 400",
            sku: "UF006330400",
            image: "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_HD_FH_SDM_TF_627.png?v=1738390379",
          },
          withBag: {
            handle: "hd-sdm-c75-constant-fh-curve-400-incl-mastbag",
            name: "HD SDM C75 Constant FH Curve 400 Incl. Mastbag",
            sku: "UF096330400",
            image: "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_HD_FH_SDM_TF_627.png?v=1738390379",
          },
        },
        elite: {
          base: {
            handle: "elite-sdm-c100-constant-fh-curve-400-incl-mastbag",
            name: "Elite SDM C100 Constant FH Curve 400 Incl. Mastbag",
            sku: "UF096430400",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_Elite_FH_SDM_TF_631_e755da37-58ff-45ea-8ba0-44396228bdd2.png?v=1738344262",
            specs: {
              length: 400,
              diameter: "SDM",
              curve: "Constant FH Curve",
              carbon: "C100",
              carbonQuality: "T700 & T800",
              imcs: 19,
              baseFlex: 64,
              topFlex: 79,
              finishing: "Matte Black Spiral Taped",
              ferrule: "Universal Ferrule System",
              maxInsertion: "Maximum 45",
              weight: 1.46,
            },
          },
          mastOnly: {
            handle: "elite-sdm-c100-constant-fh-curve-400",
            name: "Elite SDM C100 Constant FH Curve 400",
            sku: "UF006430400",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_Elite_FH_SDM_TF_631_4818aa4b-1c20-43c5-800d-ac5db1d1e31c.png?v=1738344183",
          },
          withBag: {
            handle: "elite-sdm-c100-constant-fh-curve-400-incl-mastbag",
            name: "Elite SDM C100 Constant FH Curve 400 Incl. Mastbag",
            sku: "UF096430400",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_Elite_FH_SDM_TF_631_e755da37-58ff-45ea-8ba0-44396228bdd2.png?v=1738344262",
          },
        },
      },
      430: {
        essentials: {
          base: {
            handle: "essentials-sdm-c50-constant-fh-curve-430-incl-mastbag",
            name: "Essentials SDM C50 Constant FH Curve 430 Incl. Mastbag",
            sku: "UF096030430",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_Essential_FH_SDM_TF_620_e5ba973e-7de2-4245-a641-46e0c8e4e136.png?v=1738391887",
            specs: {
              length: 430,
              diameter: "SDM",
              curve: "Constant FH Curve",
              carbon: "C50",
              carbonQuality: "T700",
              imcs: 21,
              baseFlex: 64,
              topFlex: 79,
              finishing: "Matte Black Spiral Taped",
              ferrule: "Universal Ferrule System",
              maxInsertion: "Maximum 45",
              weight: 2.33,
            },
          },
          mastOnly: {
            handle: "essentials-sdm-c50-constant-fh-curve-430",
            name: "Essentials SDM C50 Constant FH Curve 430",
            sku: "UF006030430",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_Essential_FH_SDM_TF_620_e5ba973e-7de2-4245-a641-46e0c8e4e136.png?v=1738391887",
          },
          withBag: {
            handle: "essentials-sdm-c50-constant-fh-curve-430-incl-mastbag",
            name: "Essentials SDM C50 Constant FH Curve 430 Incl. Mastbag",
            sku: "UF096030430",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_Essential_FH_SDM_TF_620_e5ba973e-7de2-4245-a641-46e0c8e4e136.png?v=1738391887",
          },
        },
        hd: {
          base: {
            handle: "hd-sdm-c75-constant-fh-curve-430-incl-mastbag",
            name: "HD SDM C75 Constant FH Curve 430 Incl. Mastbag",
            sku: "UF096330430",
            image: "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_HD_FH_SDM_TF_627.png?v=1738390379",
            specs: {
              length: 430,
              diameter: "SDM",
              curve: "Constant FH Curve",
              carbon: "C75",
              carbonQuality: "T700",
              imcs: 21,
              baseFlex: 64,
              topFlex: 79,
              finishing: "Matte Black Spiral Taped",
              ferrule: "Universal Ferrule System",
              maxInsertion: "Maximum 45",
              weight: 1.84,
            },
          },
          mastOnly: {
            handle: "hd-sdm-c75-constant-fh-curve-430",
            name: "HD SDM C75 Constant FH Curve 430",
            sku: "UF006330430",
            image: "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_HD_FH_SDM_TF_627.png?v=1738390379",
          },
          withBag: {
            handle: "hd-sdm-c75-constant-fh-curve-430-incl-mastbag",
            name: "HD SDM C75 Constant FH Curve 430 Incl. Mastbag",
            sku: "UF096330430",
            image: "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_HD_FH_SDM_TF_627.png?v=1738390379",
          },
        },
        elite: {
          base: {
            handle: "elite-sdm-c100-constant-fh-curve-430-incl-mastbag",
            name: "Elite SDM C100 Constant FH Curve 430 Incl. Mastbag",
            sku: "UF096430430",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_Elite_FH_SDM_TF_631_e755da37-58ff-45ea-8ba0-44396228bdd2.png?v=1738344262",
            specs: {
              length: 430,
              diameter: "SDM",
              curve: "Constant FH Curve",
              carbon: "C100",
              carbonQuality: "T700 & T800",
              imcs: 21,
              baseFlex: 64,
              topFlex: 79,
              finishing: "Matte Black Spiral Taped",
              ferrule: "Universal Ferrule System",
              maxInsertion: "Maximum 45",
              weight: 1.65,
            },
          },
          mastOnly: {
            handle: "elite-sdm-c100-constant-fh-curve-430",
            name: "Elite SDM C100 Constant FH Curve 430",
            sku: "UF006430430",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_Elite_FH_SDM_TF_631_e755da37-58ff-45ea-8ba0-44396228bdd2.png?v=1738344262",
          },
          withBag: {
            handle: "elite-sdm-c100-constant-fh-curve-430-incl-mastbag",
            name: "Elite SDM C100 Constant FH Curve 430 Incl. Mastbag",
            sku: "UF096430430",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_Elite_FH_SDM_TF_631_e755da37-58ff-45ea-8ba0-44396228bdd2.png?v=1738344262",
          },
        },
      },
      460: {
        essentials: {
          base: {
            handle: "essentials-sdm-c50-constant-fh-curve-460-incl-mastbag",
            name: "Essentials SDM C50 Constant FH Curve 460 Incl. Mastbag",
            sku: "UF096030460",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_Essential_FH_SDM_TF_620_e5ba973e-7de2-4245-a641-46e0c8e4e136.png?v=1738391887",
            specs: {
              length: 460,
              diameter: "SDM",
              curve: "Constant FH Curve",
              carbon: "C50",
              carbonQuality: "T700",
              imcs: 25,
              baseFlex: 64,
              topFlex: 79,
              finishing: "Matte Black Spiral Taped",
              ferrule: "Universal Ferrule System",
              maxInsertion: "Maximum 45",
              weight: 2.62,
            },
          },
          mastOnly: {
            handle: "essentials-sdm-c50-constant-fh-curve-460",
            name: "Essentials SDM C50 Constant FH Curve 460",
            sku: "UF006030460",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_Essential_FH_SDM_TF_620_e5ba973e-7de2-4245-a641-46e0c8e4e136.png?v=1738391887",
          },
          withBag: {
            handle: "essentials-sdm-c50-constant-fh-curve-460-incl-mastbag",
            name: "Essentials SDM C50 Constant FH Curve 460 Incl. Mastbag",
            sku: "UF096030460",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_Essential_FH_SDM_TF_620_e5ba973e-7de2-4245-a641-46e0c8e4e136.png?v=1738391887",
          },
        },
        hd: {
          base: {
            handle: "hd-sdm-c75-constant-fh-curve-460-incl-mastbag",
            name: "HD SDM C75 Constant FH Curve 460 Incl. Mastbag",
            sku: "UF096330460",
            image: "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_HD_FH_SDM_TF_627.png?v=1738390379",
            specs: {
              length: 460,
              diameter: "SDM",
              curve: "Constant FH Curve",
              carbon: "C75",
              carbonQuality: "T700",
              imcs: 25,
              baseFlex: 64,
              topFlex: 79,
              finishing: "Matte Black Spiral Taped",
              ferrule: "Universal Ferrule System",
              maxInsertion: "Maximum 45",
              weight: 2.14,
            },
          },
          mastOnly: {
            handle: "hd-sdm-c75-constant-fh-curve-460",
            name: "HD SDM C75 Constant FH Curve 460",
            sku: "UF006330460",
            image: "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_HD_FH_SDM_TF_627.png?v=1738390379",
          },
          withBag: {
            handle: "hd-sdm-c75-constant-fh-curve-460-incl-mastbag",
            name: "HD SDM C75 Constant FH Curve 460 Incl. Mastbag",
            sku: "UF096330460",
            image: "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_HD_FH_SDM_TF_627.png?v=1738390379",
          },
        },
        elite: {
          base: {
            handle: "elite-sdm-c100-constant-fh-curve-460-incl-mastbag",
            name: "Elite SDM C100 Constant FH Curve 460 Incl. Mastbag",
            sku: "UF096430460",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_Elite_FH_SDM_TF_631_e755da37-58ff-45ea-8ba0-44396228bdd2.png?v=1738344262",
            specs: {
              length: 460,
              diameter: "SDM",
              curve: "Constant FH Curve",
              carbon: "C100",
              carbonQuality: "T700 & T800",
              imcs: 25,
              baseFlex: 64,
              topFlex: 79,
              finishing: "Matte Black Spiral Taped",
              ferrule: "Universal Ferrule System",
              maxInsertion: "Maximum 45",
              weight: 1.89,
            },
          },
          mastOnly: {
            handle: "elite-sdm-c100-constant-fh-curve-460",
            name: "Elite SDM C100 Constant FH Curve 460",
            sku: "UF006430460",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_Elite_FH_SDM_TF_631_e755da37-58ff-45ea-8ba0-44396228bdd2.png?v=1738344262",
          },
          withBag: {
            handle: "elite-sdm-c100-constant-fh-curve-460-incl-mastbag",
            name: "Elite SDM C100 Constant FH Curve 460 Incl. Mastbag",
            sku: "UF096430460",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_Elite_FH_SDM_TF_631_e755da37-58ff-45ea-8ba0-44396228bdd2.png?v=1738344262",
          },
        },
      },
      490: {
        essentials: {
          base: {
            handle: "essentials-sdm-c50-constant-fh-curve-490-incl-mastbag",
            name: "Essentials SDM C50 Constant FH Curve 490 Incl. Mastbag",
            sku: "UF096030490",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_Essential_FH_SDM_TF_620_e5ba973e-7de2-4245-a641-46e0c8e4e136.png?v=1738391887",
            specs: {
              length: 490,
              diameter: "SDM",
              curve: "Constant FH Curve",
              carbon: "C50",
              carbonQuality: "T700",
              imcs: 29,
              baseFlex: 64,
              topFlex: 79,
              finishing: "Matte Black Spiral Taped",
              ferrule: "Universal Ferrule System",
              maxInsertion: "Maximum 45",
              weight: 2.91,
            },
          },
          mastOnly: {
            handle: "essentials-sdm-c50-constant-fh-curve-490",
            name: "Essentials SDM C50 Constant FH Curve 490",
            sku: "UF006030490",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_Essential_FH_SDM_TF_620_e5ba973e-7de2-4245-a641-46e0c8e4e136.png?v=1738391887",
          },
          withBag: {
            handle: "essentials-sdm-c50-constant-fh-curve-490-incl-mastbag",
            name: "Essentials SDM C50 Constant FH Curve 490 Incl. Mastbag",
            sku: "UF096030490",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_Essential_FH_SDM_TF_620_e5ba973e-7de2-4245-a641-46e0c8e4e136.png?v=1738391887",
          },
        },
        hd: {
          base: {
            handle: "hd-sdm-c75-constant-fh-curve-490-incl-mastbag",
            name: "HD SDM C75 Constant FH Curve 490 Incl. Mastbag",
            sku: "UF096330490",
            image: "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_HD_FH_SDM_TF_627.png?v=1738390379",
            specs: {
              length: 490,
              diameter: "SDM",
              curve: "Constant FH Curve",
              carbon: "C75",
              carbonQuality: "T700",
              imcs: 29,
              baseFlex: 64,
              topFlex: 79,
              finishing: "Matte Black Spiral Taped",
              ferrule: "Universal Ferrule System",
              maxInsertion: "Maximum 60",
              weight: 2.43,
            },
          },
          mastOnly: {
            handle: "hd-sdm-c75-constant-fh-curve-490",
            name: "HD SDM C75 Constant FH Curve 490",
            sku: "UF006330490",
            image: "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_HD_FH_SDM_TF_627.png?v=1738390379",
          },
          withBag: {
            handle: "hd-sdm-c75-constant-fh-curve-490-incl-mastbag",
            name: "HD SDM C75 Constant FH Curve 490 Incl. Mastbag",
            sku: "UF096330490",
            image: "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_HD_FH_SDM_TF_627.png?v=1738390379",
          },
        },
        elite: {
          base: {
            handle: "elite-sdm-c100-constant-fh-curve-490-incl-mastbag",
            name: "Elite SDM C100 Constant FH Curve 490 Incl. Mastbag",
            sku: "UF096430490",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_Elite_FH_SDM_TF_631_e755da37-58ff-45ea-8ba0-44396228bdd2.png?v=1738344262",
            specs: {
              length: 490,
              diameter: "SDM",
              curve: "Constant FH Curve",
              carbon: "C100",
              carbonQuality: "T700 & T800",
              imcs: 29,
              baseFlex: 64,
              topFlex: 79,
              finishing: "Matte Black Spiral Taped",
              ferrule: "Universal Ferrule System",
              maxInsertion: "Maximum 60",
              weight: 2.14,
            },
          },
          mastOnly: {
            handle: "elite-sdm-c100-constant-fh-curve-490",
            name: "Elite SDM C100 Constant FH Curve 490",
            sku: "UF006430490",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_Elite_FH_SDM_TF_631_e755da37-58ff-45ea-8ba0-44396228bdd2.png?v=1738344262",
          },
          withBag: {
            handle: "elite-sdm-c100-constant-fh-curve-490-incl-mastbag",
            name: "Elite SDM C100 Constant FH Curve 490 Incl. Mastbag",
            sku: "UF096430490",
            image:
              "https://cdn.shopify.com/s/files/1/0689/9872/5855/files/UF_Mast_Elite_FH_SDM_TF_631_e755da37-58ff-45ea-8ba0-44396228bdd2.png?v=1738344262",
          },
        },
      },
    },
  },
  mastBags: {
    340: {
      handle: "mastbag-340-rdm-and-sdm-fit",
      name: null,
      sku: "UF050011340",
      image: null,
    },
    370: {
      handle: "mastbag-370-rdm-and-sdm-fit",
      name: null,
      sku: "UF050011370",
      image: null,
    },
    400: {
      handle: "mastbag-400-rdm-and-sdm-fit",
      name: null,
      sku: "UF050011400",
      image: null,
    },
    430: {
      handle: "mastbag-430-rdm-and-sdm-fit",
      name: null,
      sku: "UF050011430",
      image: null,
    },
    460: {
      handle: "mastbag-460-rdm-and-sdm-fit",
      name: null,
      sku: "UF050011460",
      image: null,
    },
    490: {
      handle: "mastbag-490-rdm-and-sdm-fit",
      name: null,
      sku: "UF050011490",
      image: null,
    },
    520: {
      handle: "mastbag-520-rdm-and-sdm-fit",
      name: null,
      sku: "UF050011520",
      image: null,
    },
  },
};
